import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FieldType = /*#__PURE__*/function (FieldType) {
  FieldType[FieldType["FIELD_TYPE_INVALID"] = 0] = "FIELD_TYPE_INVALID";
  FieldType[FieldType["FIELD_TYPE_STRING"] = 1] = "FIELD_TYPE_STRING";
  FieldType[FieldType["FIELD_TYPE_INTEGER"] = 2] = "FIELD_TYPE_INTEGER";
  FieldType[FieldType["FIELD_TYPE_DATE"] = 3] = "FIELD_TYPE_DATE";
  FieldType[FieldType["FIELD_TYPE_DROPDOWN"] = 4] = "FIELD_TYPE_DROPDOWN";
  FieldType[FieldType["FIELD_TYPE_CURRENCY"] = 5] = "FIELD_TYPE_CURRENCY";
  FieldType[FieldType["FIELD_TYPE_EMAIL"] = 6] = "FIELD_TYPE_EMAIL";
  FieldType[FieldType["FIELD_TYPE_PHONE"] = 7] = "FIELD_TYPE_PHONE";
  FieldType[FieldType["FIELD_TYPE_BOOLEAN"] = 8] = "FIELD_TYPE_BOOLEAN";
  FieldType[FieldType["FIELD_TYPE_TAG"] = 9] = "FIELD_TYPE_TAG";
  FieldType[FieldType["FIELD_TYPE_DATETIME"] = 10] = "FIELD_TYPE_DATETIME";
  FieldType[FieldType["FIELD_TYPE_STRING_LIST"] = 11] = "FIELD_TYPE_STRING_LIST";
  FieldType[FieldType["FIELD_TYPE_GEOPOINT"] = 12] = "FIELD_TYPE_GEOPOINT";
  FieldType[FieldType["FIELD_TYPE_FLOAT"] = 13] = "FIELD_TYPE_FLOAT";
  return FieldType;
}(FieldType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DateDefault = /*#__PURE__*/function (DateDefault) {
  DateDefault[DateDefault["DATE_DEFAULT_INVALID"] = 0] = "DATE_DEFAULT_INVALID";
  DateDefault[DateDefault["DATE_DEFAULT_TODAY"] = 1] = "DATE_DEFAULT_TODAY";
  DateDefault[DateDefault["DATE_DEFAULT_YESTERDAY"] = 2] = "DATE_DEFAULT_YESTERDAY";
  DateDefault[DateDefault["DATE_DEFAULT_TOMORROW"] = 3] = "DATE_DEFAULT_TOMORROW";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_WEEK"] = 4] = "DATE_DEFAULT_THIS_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_WEEK"] = 5] = "DATE_DEFAULT_LAST_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_WEEK"] = 6] = "DATE_DEFAULT_NEXT_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_MONTH"] = 7] = "DATE_DEFAULT_THIS_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_MONTH"] = 8] = "DATE_DEFAULT_LAST_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_MONTH"] = 9] = "DATE_DEFAULT_NEXT_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_QUARTER"] = 10] = "DATE_DEFAULT_THIS_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_QUARTER"] = 11] = "DATE_DEFAULT_LAST_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_QUARTER"] = 12] = "DATE_DEFAULT_NEXT_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_YEAR"] = 13] = "DATE_DEFAULT_THIS_YEAR";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_YEAR"] = 14] = "DATE_DEFAULT_LAST_YEAR";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_YEAR"] = 15] = "DATE_DEFAULT_NEXT_YEAR";
  return DateDefault;
}(DateDefault || {});
var FilterGroupOperator = /*#__PURE__*/function (FilterGroupOperator) {
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_INVALID"] = 0] = "FILTER_GROUP_OPERATOR_INVALID";
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_AND"] = 1] = "FILTER_GROUP_OPERATOR_AND";
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_OR"] = 2] = "FILTER_GROUP_OPERATOR_OR";
  return FilterGroupOperator;
}(FilterGroupOperator || {});
var FilterOperator = /*#__PURE__*/function (FilterOperator) {
  FilterOperator[FilterOperator["FILTER_OPERATOR_INVALID"] = 0] = "FILTER_OPERATOR_INVALID";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_EMPTY"] = 1] = "FILTER_OPERATOR_IS_EMPTY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_EMPTY"] = 2] = "FILTER_OPERATOR_IS_NOT_EMPTY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS"] = 3] = "FILTER_OPERATOR_IS";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT"] = 4] = "FILTER_OPERATOR_IS_NOT";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_ANY"] = 5] = "FILTER_OPERATOR_IS_ANY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_ANY"] = 6] = "FILTER_OPERATOR_IS_NOT_ANY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_ALL"] = 7] = "FILTER_OPERATOR_IS_ALL";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_ALL"] = 8] = "FILTER_OPERATOR_IS_NOT_ALL";
  FilterOperator[FilterOperator["FILTER_OPERATOR_CONTAINS"] = 9] = "FILTER_OPERATOR_CONTAINS";
  FilterOperator[FilterOperator["FILTER_OPERATOR_DOES_NOT_CONTAIN"] = 10] = "FILTER_OPERATOR_DOES_NOT_CONTAIN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_EQUAL_TO"] = 11] = "FILTER_OPERATOR_IS_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_EQUAL_TO"] = 12] = "FILTER_OPERATOR_IS_NOT_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_GREATER_THAN"] = 13] = "FILTER_OPERATOR_IS_GREATER_THAN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO"] = 14] = "FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_LESS_THAN"] = 15] = "FILTER_OPERATOR_IS_LESS_THAN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO"] = 16] = "FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BEFORE"] = 17] = "FILTER_OPERATOR_IS_BEFORE";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BEFORE_OR_ON"] = 18] = "FILTER_OPERATOR_IS_BEFORE_OR_ON";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_AFTER"] = 19] = "FILTER_OPERATOR_IS_AFTER";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_AFTER_OR_ON"] = 20] = "FILTER_OPERATOR_IS_AFTER_OR_ON";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BETWEEN"] = 21] = "FILTER_OPERATOR_IS_BETWEEN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_BETWEEN"] = 22] = "FILTER_OPERATOR_IS_NOT_BETWEEN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_VALID"] = 23] = "FILTER_OPERATOR_IS_VALID";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_VALID"] = 24] = "FILTER_OPERATOR_IS_NOT_VALID";
  return FilterOperator;
}(FilterOperator || {});
var FilterType = /*#__PURE__*/function (FilterType) {
  FilterType[FilterType["FILTER_TYPE_INVALID"] = 0] = "FILTER_TYPE_INVALID";
  FilterType[FilterType["FILTER_TYPE_STRING"] = 1] = "FILTER_TYPE_STRING";
  FilterType[FilterType["FILTER_TYPE_INTEGER"] = 2] = "FILTER_TYPE_INTEGER";
  FilterType[FilterType["FILTER_TYPE_DATE"] = 3] = "FILTER_TYPE_DATE";
  FilterType[FilterType["FILTER_TYPE_FLOAT"] = 4] = "FILTER_TYPE_FLOAT";
  FilterType[FilterType["FILTER_TYPE_BOOLEAN"] = 5] = "FILTER_TYPE_BOOLEAN";
  FilterType[FilterType["FILTER_TYPE_TAG"] = 6] = "FILTER_TYPE_TAG";
  FilterType[FilterType["FILTER_TYPE_PHONE"] = 8] = "FILTER_TYPE_PHONE";
  return FilterType;
}(FilterType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ValidateCrmObjectResponseFieldUniqueness = /*#__PURE__*/function (ValidateCrmObjectResponseFieldUniqueness) {
  ValidateCrmObjectResponseFieldUniqueness[ValidateCrmObjectResponseFieldUniqueness["FIELD_UNIQUENESS_INVALID"] = 0] = "FIELD_UNIQUENESS_INVALID";
  ValidateCrmObjectResponseFieldUniqueness[ValidateCrmObjectResponseFieldUniqueness["FIELD_UNIQUENESS_NONE"] = 1] = "FIELD_UNIQUENESS_NONE";
  ValidateCrmObjectResponseFieldUniqueness[ValidateCrmObjectResponseFieldUniqueness["FIELD_UNIQUENESS_WARNING"] = 2] = "FIELD_UNIQUENESS_WARNING";
  ValidateCrmObjectResponseFieldUniqueness[ValidateCrmObjectResponseFieldUniqueness["FIELD_UNIQUENESS_ENFORCED"] = 3] = "FIELD_UNIQUENESS_ENFORCED";
  return ValidateCrmObjectResponseFieldUniqueness;
}(ValidateCrmObjectResponseFieldUniqueness || {});
var ProjectionFilterType = /*#__PURE__*/function (ProjectionFilterType) {
  ProjectionFilterType[ProjectionFilterType["PROJECTION_FILTER_TYPE_INVALID"] = 0] = "PROJECTION_FILTER_TYPE_INVALID";
  ProjectionFilterType[ProjectionFilterType["PROJECTION_FILTER_TYPE_FIELD_TYPE"] = 1] = "PROJECTION_FILTER_TYPE_FIELD_TYPE";
  ProjectionFilterType[ProjectionFilterType["PROJECTION_FILTER_TYPE_INCLUDE_DELETED"] = 2] = "PROJECTION_FILTER_TYPE_INCLUDE_DELETED";
  return ProjectionFilterType;
}(ProjectionFilterType || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_INVALID"] = 0] = "SORT_DIRECTION_INVALID";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
var ValidateCrmObjectResponseValidationErrorSeverity = /*#__PURE__*/function (ValidateCrmObjectResponseValidationErrorSeverity) {
  ValidateCrmObjectResponseValidationErrorSeverity[ValidateCrmObjectResponseValidationErrorSeverity["VALIDATION_ERROR_SEVERITY_UNKNOWN"] = 0] = "VALIDATION_ERROR_SEVERITY_UNKNOWN";
  ValidateCrmObjectResponseValidationErrorSeverity[ValidateCrmObjectResponseValidationErrorSeverity["VALIDATION_ERROR_SEVERITY_INVALID"] = 1] = "VALIDATION_ERROR_SEVERITY_INVALID";
  ValidateCrmObjectResponseValidationErrorSeverity[ValidateCrmObjectResponseValidationErrorSeverity["VALIDATION_ERROR_SEVERITY_WARNING"] = 2] = "VALIDATION_ERROR_SEVERITY_WARNING";
  return ValidateCrmObjectResponseValidationErrorSeverity;
}(ValidateCrmObjectResponseValidationErrorSeverity || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MetricType = /*#__PURE__*/function (MetricType) {
  MetricType[MetricType["METRIC_TYPE_INVALID"] = 0] = "METRIC_TYPE_INVALID";
  MetricType[MetricType["METRIC_TYPE_OUTBOUND_CALLS"] = 1] = "METRIC_TYPE_OUTBOUND_CALLS";
  MetricType[MetricType["METRIC_TYPE_INBOUND_CALLS"] = 2] = "METRIC_TYPE_INBOUND_CALLS";
  MetricType[MetricType["METRIC_TYPE_EMAILS_SENT"] = 3] = "METRIC_TYPE_EMAILS_SENT";
  MetricType[MetricType["METRIC_TYPE_EMAILS_RECEIVED"] = 4] = "METRIC_TYPE_EMAILS_RECEIVED";
  MetricType[MetricType["METRIC_TYPE_MEETINGS"] = 5] = "METRIC_TYPE_MEETINGS";
  return MetricType;
}(MetricType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DuplicateHandlingType = /*#__PURE__*/function (DuplicateHandlingType) {
  DuplicateHandlingType[DuplicateHandlingType["DUPLICATE_HANDLING_TYPE_INVALID"] = 0] = "DUPLICATE_HANDLING_TYPE_INVALID";
  DuplicateHandlingType[DuplicateHandlingType["DUPLICATE_HANDLING_TYPE_SKIP"] = 1] = "DUPLICATE_HANDLING_TYPE_SKIP";
  DuplicateHandlingType[DuplicateHandlingType["DUPLICATE_HANDLING_TYPE_UPDATE"] = 2] = "DUPLICATE_HANDLING_TYPE_UPDATE";
  return DuplicateHandlingType;
}(DuplicateHandlingType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var NullValue = /*#__PURE__*/function (NullValue) {
  NullValue[NullValue["NULL_VALUE"] = 0] = "NULL_VALUE";
  return NullValue;
}(NullValue || {});
// *********************************

function enumStringToValue$j(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$i(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$h(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArchiveFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ArchiveFieldSchemaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class CreateFieldSchemaRequest {
  static fromProto(proto) {
    let m = new CreateFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = FieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class CreateFieldSchemaResponse {
  static fromProto(proto) {
    let m = new CreateFieldSchemaResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class DropdownOption {
  static fromProto(proto) {
    let m = new DropdownOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class FieldSchema {
  static fromProto(proto) {
    let m = new FieldSchema();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$h(FieldType, proto.fieldType);
    }
    if (proto.dropdownOptions) {
      m.dropdownOptions = proto.dropdownOptions.map(DropdownOption.fromProto);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.fieldDescription !== 'undefined') {
      toReturn['fieldDescription'] = this.fieldDescription;
    }
    if (typeof this.dropdownOptions !== 'undefined' && this.dropdownOptions !== null) {
      toReturn['dropdownOptions'] = 'toApiJson' in this.dropdownOptions ? this.dropdownOptions.toApiJson() : this.dropdownOptions;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.readonly !== 'undefined') {
      toReturn['readonly'] = this.readonly;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    return toReturn;
  }
}
class ListFieldSchemaRequestFilters {
  static fromProto(proto) {
    let m = new ListFieldSchemaRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onlyArchived !== 'undefined') {
      toReturn['onlyArchived'] = this.onlyArchived;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ListMultiLocationFieldSchemaRequestFilters {
  static fromProto(proto) {
    let m = new ListMultiLocationFieldSchemaRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onlyArchived !== 'undefined') {
      toReturn['onlyArchived'] = this.onlyArchived;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetMultiFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetMultiFieldSchemaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class GetMultiFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetMultiFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(FieldSchema.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    return toReturn;
  }
}
class ListFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ListFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListFieldSchemaRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListFieldSchemaResponse {
  static fromProto(proto) {
    let m = new ListFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(FieldSchema.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListMultiLocationFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ListMultiLocationFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListMultiLocationFieldSchemaRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaces !== 'undefined') {
      toReturn['namespaces'] = this.namespaces;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListMultiLocationFieldSchemaResponse {
  static fromProto(proto) {
    let m = new ListMultiLocationFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(FieldSchema.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UnarchiveFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UnarchiveFieldSchemaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class UpdateFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UpdateFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = FieldSchema.fromProto(proto.fieldSchema);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$g(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Filter {
  static fromProto(proto) {
    let m = new Filter();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$g(FilterOperator, proto.operator);
    }
    if (proto.values) {
      m.values = proto.values.map(FilterValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? this.values.toApiJson() : this.values;
    }
    if (typeof this.floatTolerance !== 'undefined') {
      toReturn['floatTolerance'] = this.floatTolerance;
    }
    return toReturn;
  }
}
class FilterGroup {
  static fromProto(proto) {
    let m = new FilterGroup();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$g(FilterGroupOperator, proto.operator);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(Filter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class Phone {
  static fromProto(proto) {
    let m = new Phone();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isoCountryCode !== 'undefined') {
      toReturn['isoCountryCode'] = this.isoCountryCode;
    }
    if (typeof this.nationalNumber !== 'undefined') {
      toReturn['nationalNumber'] = this.nationalNumber;
    }
    if (typeof this.extension !== 'undefined') {
      toReturn['extension'] = this.extension;
    }
    return toReturn;
  }
}
class FilterValue {
  static fromProto(proto) {
    let m = new FilterValue();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.dateDefault) {
      m.dateDefault = enumStringToValue$g(DateDefault, proto.dateDefault);
    }
    if (proto.phone) {
      m.phone = Phone.fromProto(proto.phone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.boolean !== 'undefined') {
      toReturn['boolean'] = this.boolean;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.float !== 'undefined') {
      toReturn['float'] = this.float;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.dateDefault !== 'undefined') {
      toReturn['dateDefault'] = this.dateDefault;
    }
    if (typeof this.phone !== 'undefined' && this.phone !== null) {
      toReturn['phone'] = 'toApiJson' in this.phone ? this.phone.toApiJson() : this.phone;
    }
    return toReturn;
  }
}
function enumStringToValue$f(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetOpportunityValueSummaryResponseAmounts {
  static fromProto(proto) {
    let m = new GetOpportunityValueSummaryResponseAmounts();
    m = Object.assign(m, proto);
    if (proto.total) {
      m.total = Currency.fromProto(proto.total);
    }
    if (proto.estimated) {
      m.estimated = Currency.fromProto(proto.estimated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.total !== 'undefined' && this.total !== null) {
      toReturn['total'] = 'toApiJson' in this.total ? this.total.toApiJson() : this.total;
    }
    if (typeof this.estimated !== 'undefined' && this.estimated !== null) {
      toReturn['estimated'] = 'toApiJson' in this.estimated ? this.estimated.toApiJson() : this.estimated;
    }
    return toReturn;
  }
}
class CreateCrmObjectRequest {
  static fromProto(proto) {
    let m = new CreateCrmObjectRequest();
    m = Object.assign(m, proto);
    if (proto.crmObject) {
      m.crmObject = CrmObject.fromProto(proto.crmObject);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObject !== 'undefined' && this.crmObject !== null) {
      toReturn['crmObject'] = 'toApiJson' in this.crmObject ? this.crmObject.toApiJson() : this.crmObject;
    }
    return toReturn;
  }
}
class CreateCrmObjectResponse {
  static fromProto(proto) {
    let m = new CreateCrmObjectResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    return toReturn;
  }
}
class CrmObject {
  static fromProto(proto) {
    let m = new CrmObject();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(FieldValue.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.idempotencyId !== 'undefined') {
      toReturn['idempotencyId'] = this.idempotencyId;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class CrmObjectSearch {
  static fromProto(proto) {
    let m = new CrmObjectSearch();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class Currency {
  static fromProto(proto) {
    let m = new Currency();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class DeleteCrmObjectRequest {
  static fromProto(proto) {
    let m = new DeleteCrmObjectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    return toReturn;
  }
}
class FieldValue {
  static fromProto(proto) {
    let m = new FieldValue();
    m = Object.assign(m, proto);
    if (proto.nullValue) {
      m.nullValue = enumStringToValue$f(NullValue, proto.nullValue);
    }
    if (proto.integerValue) {
      m.integerValue = parseInt(proto.integerValue, 10);
    }
    if (proto.dateValue) {
      m.dateValue = new Date(proto.dateValue);
    }
    if (proto.stringValues) {
      m.stringValues = StringList.fromProto(proto.stringValues);
    }
    if (proto.geopointValue) {
      m.geopointValue = Geopoint.fromProto(proto.geopointValue);
    }
    if (proto.phoneFieldValues) {
      m.phoneFieldValues = PhoneFields.fromProto(proto.phoneFieldValues);
    }
    if (proto.currencyValue) {
      m.currencyValue = Currency.fromProto(proto.currencyValue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.nullValue !== 'undefined') {
      toReturn['nullValue'] = this.nullValue;
    }
    if (typeof this.integerValue !== 'undefined') {
      toReturn['integerValue'] = this.integerValue;
    }
    if (typeof this.stringValue !== 'undefined') {
      toReturn['stringValue'] = this.stringValue;
    }
    if (typeof this.dateValue !== 'undefined' && this.dateValue !== null) {
      toReturn['dateValue'] = 'toApiJson' in this.dateValue ? this.dateValue.toApiJson() : this.dateValue;
    }
    if (typeof this.booleanValue !== 'undefined') {
      toReturn['booleanValue'] = this.booleanValue;
    }
    if (typeof this.stringValues !== 'undefined' && this.stringValues !== null) {
      toReturn['stringValues'] = 'toApiJson' in this.stringValues ? this.stringValues.toApiJson() : this.stringValues;
    }
    if (typeof this.geopointValue !== 'undefined' && this.geopointValue !== null) {
      toReturn['geopointValue'] = 'toApiJson' in this.geopointValue ? this.geopointValue.toApiJson() : this.geopointValue;
    }
    if (typeof this.floatValue !== 'undefined') {
      toReturn['floatValue'] = this.floatValue;
    }
    if (typeof this.phoneFieldValues !== 'undefined' && this.phoneFieldValues !== null) {
      toReturn['phoneFieldValues'] = 'toApiJson' in this.phoneFieldValues ? this.phoneFieldValues.toApiJson() : this.phoneFieldValues;
    }
    if (typeof this.currencyValue !== 'undefined' && this.currencyValue !== null) {
      toReturn['currencyValue'] = 'toApiJson' in this.currencyValue ? this.currencyValue.toApiJson() : this.currencyValue;
    }
    return toReturn;
  }
}
class Geopoint {
  static fromProto(proto) {
    let m = new Geopoint();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lat !== 'undefined') {
      toReturn['lat'] = this.lat;
    }
    if (typeof this.lon !== 'undefined') {
      toReturn['lon'] = this.lon;
    }
    return toReturn;
  }
}
class GetMultiCrmObjectRequest {
  static fromProto(proto) {
    let m = new GetMultiCrmObjectRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.projectionFilters) {
      m.projectionFilters = proto.projectionFilters.map(ObjectProjectionFilter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectIds !== 'undefined') {
      toReturn['crmObjectIds'] = this.crmObjectIds;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.projectionFilters !== 'undefined' && this.projectionFilters !== null) {
      toReturn['projectionFilters'] = 'toApiJson' in this.projectionFilters ? this.projectionFilters.toApiJson() : this.projectionFilters;
    }
    return toReturn;
  }
}
class GetMultiCrmObjectResponse {
  static fromProto(proto) {
    let m = new GetMultiCrmObjectResponse();
    m = Object.assign(m, proto);
    if (proto.crmObjects) {
      m.crmObjects = proto.crmObjects.map(CrmObject.fromProto);
    }
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(FieldSchema.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjects !== 'undefined' && this.crmObjects !== null) {
      toReturn['crmObjects'] = 'toApiJson' in this.crmObjects ? this.crmObjects.toApiJson() : this.crmObjects;
    }
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    return toReturn;
  }
}
class GetOpportunityValueSummaryRequest {
  static fromProto(proto) {
    let m = new GetOpportunityValueSummaryRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = FilterGroup.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class GetOpportunityValueSummaryResponse {
  static fromProto(proto) {
    let m = new GetOpportunityValueSummaryResponse();
    m = Object.assign(m, proto);
    if (proto.stages) {
      m.stages = proto.stages.map(GetOpportunityValueSummaryResponseStageAmounts.fromProto);
    }
    if (proto.pipeline) {
      m.pipeline = GetOpportunityValueSummaryResponseAmounts.fromProto(proto.pipeline);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stages !== 'undefined' && this.stages !== null) {
      toReturn['stages'] = 'toApiJson' in this.stages ? this.stages.toApiJson() : this.stages;
    }
    if (typeof this.pipeline !== 'undefined' && this.pipeline !== null) {
      toReturn['pipeline'] = 'toApiJson' in this.pipeline ? this.pipeline.toApiJson() : this.pipeline;
    }
    return toReturn;
  }
}
class ListCrmObjectsRequest {
  static fromProto(proto) {
    let m = new ListCrmObjectsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.search) {
      m.search = CrmObjectSearch.fromProto(proto.search);
    }
    if (proto.sortBy) {
      m.sortBy = proto.sortBy.map(SortBy.fromProto);
    }
    if (proto.filtersV2) {
      m.filtersV2 = FilterGroup.fromProto(proto.filtersV2);
    }
    if (proto.projectionFilters) {
      m.projectionFilters = proto.projectionFilters.map(ObjectProjectionFilter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.search !== 'undefined' && this.search !== null) {
      toReturn['search'] = 'toApiJson' in this.search ? this.search.toApiJson() : this.search;
    }
    if (typeof this.sortBy !== 'undefined' && this.sortBy !== null) {
      toReturn['sortBy'] = 'toApiJson' in this.sortBy ? this.sortBy.toApiJson() : this.sortBy;
    }
    if (typeof this.filtersV2 !== 'undefined' && this.filtersV2 !== null) {
      toReturn['filtersV2'] = 'toApiJson' in this.filtersV2 ? this.filtersV2.toApiJson() : this.filtersV2;
    }
    if (typeof this.projectionFilters !== 'undefined' && this.projectionFilters !== null) {
      toReturn['projectionFilters'] = 'toApiJson' in this.projectionFilters ? this.projectionFilters.toApiJson() : this.projectionFilters;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    return toReturn;
  }
}
class ListCrmObjectsResponse {
  static fromProto(proto) {
    let m = new ListCrmObjectsResponse();
    m = Object.assign(m, proto);
    if (proto.crmObjects) {
      m.crmObjects = proto.crmObjects.map(CrmObject.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjects !== 'undefined' && this.crmObjects !== null) {
      toReturn['crmObjects'] = 'toApiJson' in this.crmObjects ? this.crmObjects.toApiJson() : this.crmObjects;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListFieldOptionsRequest {
  static fromProto(proto) {
    let m = new ListFieldOptionsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    return toReturn;
  }
}
class ListFieldOptionsResponse {
  static fromProto(proto) {
    let m = new ListFieldOptionsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    return toReturn;
  }
}
class ListMultiLocationCrmObjectsRequest {
  static fromProto(proto) {
    let m = new ListMultiLocationCrmObjectsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.search) {
      m.search = CrmObjectSearch.fromProto(proto.search);
    }
    if (proto.sortBy) {
      m.sortBy = proto.sortBy.map(SortBy.fromProto);
    }
    if (proto.filtersV2) {
      m.filtersV2 = FilterGroup.fromProto(proto.filtersV2);
    }
    if (proto.projectionFilters) {
      m.projectionFilters = proto.projectionFilters.map(ObjectProjectionFilter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaces !== 'undefined') {
      toReturn['namespaces'] = this.namespaces;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.search !== 'undefined' && this.search !== null) {
      toReturn['search'] = 'toApiJson' in this.search ? this.search.toApiJson() : this.search;
    }
    if (typeof this.sortBy !== 'undefined' && this.sortBy !== null) {
      toReturn['sortBy'] = 'toApiJson' in this.sortBy ? this.sortBy.toApiJson() : this.sortBy;
    }
    if (typeof this.filtersV2 !== 'undefined' && this.filtersV2 !== null) {
      toReturn['filtersV2'] = 'toApiJson' in this.filtersV2 ? this.filtersV2.toApiJson() : this.filtersV2;
    }
    if (typeof this.projectionFilters !== 'undefined' && this.projectionFilters !== null) {
      toReturn['projectionFilters'] = 'toApiJson' in this.projectionFilters ? this.projectionFilters.toApiJson() : this.projectionFilters;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    return toReturn;
  }
}
class ListMultiLocationCrmObjectsResponse {
  static fromProto(proto) {
    let m = new ListMultiLocationCrmObjectsResponse();
    m = Object.assign(m, proto);
    if (proto.crmObjects) {
      m.crmObjects = proto.crmObjects.map(CrmObject.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjects !== 'undefined' && this.crmObjects !== null) {
      toReturn['crmObjects'] = 'toApiJson' in this.crmObjects ? this.crmObjects.toApiJson() : this.crmObjects;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListMultiLocationFieldOptionsRequest {
  static fromProto(proto) {
    let m = new ListMultiLocationFieldOptionsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaces !== 'undefined') {
      toReturn['namespaces'] = this.namespaces;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListMultiLocationFieldOptionsResponse {
  static fromProto(proto) {
    let m = new ListMultiLocationFieldOptionsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    return toReturn;
  }
}
class ObjectProjectionFilter {
  static fromProto(proto) {
    let m = new ObjectProjectionFilter();
    m = Object.assign(m, proto);
    if (proto.filterType) {
      m.filterType = enumStringToValue$f(ProjectionFilterType, proto.filterType);
    }
    if (proto.fromFieldType) {
      m.fromFieldType = enumStringToValue$f(FieldType, proto.fromFieldType);
    }
    if (proto.toFieldType) {
      m.toFieldType = enumStringToValue$f(FieldType, proto.toFieldType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filterType !== 'undefined') {
      toReturn['filterType'] = this.filterType;
    }
    if (typeof this.fromFieldType !== 'undefined') {
      toReturn['fromFieldType'] = this.fromFieldType;
    }
    if (typeof this.toFieldType !== 'undefined') {
      toReturn['toFieldType'] = this.toFieldType;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class PhoneFields {
  static fromProto(proto) {
    let m = new PhoneFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isoCountryCode !== 'undefined') {
      toReturn['isoCountryCode'] = this.isoCountryCode;
    }
    if (typeof this.nationalNumber !== 'undefined') {
      toReturn['nationalNumber'] = this.nationalNumber;
    }
    if (typeof this.extension !== 'undefined') {
      toReturn['extension'] = this.extension;
    }
    if (typeof this.e164Compliant !== 'undefined') {
      toReturn['e164Compliant'] = this.e164Compliant;
    }
    return toReturn;
  }
}
class SortBy {
  static fromProto(proto) {
    let m = new SortBy();
    m = Object.assign(m, proto);
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue$f(SortDirection, proto.sortDirection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    return toReturn;
  }
}
class GetOpportunityValueSummaryResponseStageAmounts {
  static fromProto(proto) {
    let m = new GetOpportunityValueSummaryResponseStageAmounts();
    m = Object.assign(m, proto);
    if (proto.amounts) {
      m.amounts = GetOpportunityValueSummaryResponseAmounts.fromProto(proto.amounts);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stageId !== 'undefined') {
      toReturn['stageId'] = this.stageId;
    }
    if (typeof this.amounts !== 'undefined' && this.amounts !== null) {
      toReturn['amounts'] = 'toApiJson' in this.amounts ? this.amounts.toApiJson() : this.amounts;
    }
    return toReturn;
  }
}
class StartBulkCompanyCreateRequest {
  static fromProto(proto) {
    let m = new StartBulkCompanyCreateRequest();
    m = Object.assign(m, proto);
    if (proto.crmObjects) {
      m.crmObjects = proto.crmObjects.map(CrmObject.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.crmObjects !== 'undefined' && this.crmObjects !== null) {
      toReturn['crmObjects'] = 'toApiJson' in this.crmObjects ? this.crmObjects.toApiJson() : this.crmObjects;
    }
    return toReturn;
  }
}
class StartBulkCompanyCreateResponse {
  static fromProto(proto) {
    let m = new StartBulkCompanyCreateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filterTag !== 'undefined') {
      toReturn['filterTag'] = this.filterTag;
    }
    return toReturn;
  }
}
class StringList {
  static fromProto(proto) {
    let m = new StringList();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class ValidateCrmObjectResponseUniquenessCheck {
  static fromProto(proto) {
    let m = new ValidateCrmObjectResponseUniquenessCheck();
    m = Object.assign(m, proto);
    if (proto.uniqueness) {
      m.uniqueness = enumStringToValue$f(ValidateCrmObjectResponseFieldUniqueness, proto.uniqueness);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.existingCrmObjectIds !== 'undefined') {
      toReturn['existingCrmObjectIds'] = this.existingCrmObjectIds;
    }
    if (typeof this.uniqueness !== 'undefined') {
      toReturn['uniqueness'] = this.uniqueness;
    }
    return toReturn;
  }
}
class UpdateCrmObjectRequest {
  static fromProto(proto) {
    let m = new UpdateCrmObjectRequest();
    m = Object.assign(m, proto);
    if (proto.crmObject) {
      m.crmObject = CrmObject.fromProto(proto.crmObject);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObject !== 'undefined' && this.crmObject !== null) {
      toReturn['crmObject'] = 'toApiJson' in this.crmObject ? this.crmObject.toApiJson() : this.crmObject;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class ValidateCrmObjectRequest {
  static fromProto(proto) {
    let m = new ValidateCrmObjectRequest();
    m = Object.assign(m, proto);
    if (proto.crmObject) {
      m.crmObject = CrmObject.fromProto(proto.crmObject);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObject !== 'undefined' && this.crmObject !== null) {
      toReturn['crmObject'] = 'toApiJson' in this.crmObject ? this.crmObject.toApiJson() : this.crmObject;
    }
    return toReturn;
  }
}
class ValidateCrmObjectResponse {
  static fromProto(proto) {
    let m = new ValidateCrmObjectResponse();
    m = Object.assign(m, proto);
    if (proto.errors) {
      m.errors = proto.errors.map(ValidateCrmObjectResponseValidationError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}
class ValidateCrmObjectResponseValidationError {
  static fromProto(proto) {
    let m = new ValidateCrmObjectResponseValidationError();
    m = Object.assign(m, proto);
    if (proto.severity) {
      m.severity = enumStringToValue$f(ValidateCrmObjectResponseValidationErrorSeverity, proto.severity);
    }
    if (proto.details) {
      m.details = ValidateCrmObjectResponseValidationErrorDetails.fromProto(proto.details);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ruleId !== 'undefined') {
      toReturn['ruleId'] = this.ruleId;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.severity !== 'undefined') {
      toReturn['severity'] = this.severity;
    }
    if (typeof this.details !== 'undefined' && this.details !== null) {
      toReturn['details'] = 'toApiJson' in this.details ? this.details.toApiJson() : this.details;
    }
    return toReturn;
  }
}
class ValidateCrmObjectResponseValidationErrorDetails {
  static fromProto(proto) {
    let m = new ValidateCrmObjectResponseValidationErrorDetails();
    m = Object.assign(m, proto);
    if (proto.uniquenessCheck) {
      m.uniquenessCheck = ValidateCrmObjectResponseUniquenessCheck.fromProto(proto.uniquenessCheck);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.uniquenessCheck !== 'undefined' && this.uniquenessCheck !== null) {
      toReturn['uniquenessCheck'] = 'toApiJson' in this.uniquenessCheck ? this.uniquenessCheck.toApiJson() : this.uniquenessCheck;
    }
    return toReturn;
  }
}
function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateFieldSchemaCustomizationRequest {
  static fromProto(proto) {
    let m = new CreateFieldSchemaCustomizationRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchemaCustomization) {
      m.fieldSchemaCustomization = FieldSchemaCustomization.fromProto(proto.fieldSchemaCustomization);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.fieldSchemaCustomization !== 'undefined' && this.fieldSchemaCustomization !== null) {
      toReturn['fieldSchemaCustomization'] = 'toApiJson' in this.fieldSchemaCustomization ? this.fieldSchemaCustomization.toApiJson() : this.fieldSchemaCustomization;
    }
    return toReturn;
  }
}
class FieldSchemaCustomization {
  static fromProto(proto) {
    let m = new FieldSchemaCustomization();
    m = Object.assign(m, proto);
    if (proto.restrictedFieldValues) {
      m.restrictedFieldValues = proto.restrictedFieldValues.map(FieldValue.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.restrictedFieldValues !== 'undefined' && this.restrictedFieldValues !== null) {
      toReturn['restrictedFieldValues'] = 'toApiJson' in this.restrictedFieldValues ? this.restrictedFieldValues.toApiJson() : this.restrictedFieldValues;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class GetMultiFieldSchemaCustomizationRequest {
  static fromProto(proto) {
    let m = new GetMultiFieldSchemaCustomizationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class GetMultiFieldSchemaCustomizationResponse {
  static fromProto(proto) {
    let m = new GetMultiFieldSchemaCustomizationResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemaCustomizations) {
      m.fieldSchemaCustomizations = proto.fieldSchemaCustomizations.map(FieldSchemaCustomization.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemaCustomizations !== 'undefined' && this.fieldSchemaCustomizations !== null) {
      toReturn['fieldSchemaCustomizations'] = 'toApiJson' in this.fieldSchemaCustomizations ? this.fieldSchemaCustomizations.toApiJson() : this.fieldSchemaCustomizations;
    }
    return toReturn;
  }
}
class UpdateFieldSchemaCustomizationRequest {
  static fromProto(proto) {
    let m = new UpdateFieldSchemaCustomizationRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchemaCustomization) {
      m.fieldSchemaCustomization = FieldSchemaCustomization.fromProto(proto.fieldSchemaCustomization);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.fieldSchemaCustomization !== 'undefined' && this.fieldSchemaCustomization !== null) {
      toReturn['fieldSchemaCustomization'] = 'toApiJson' in this.fieldSchemaCustomization ? this.fieldSchemaCustomization.toApiJson() : this.fieldSchemaCustomization;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FilterDefinition {
  static fromProto(proto) {
    let m = new FilterDefinition();
    m = Object.assign(m, proto);
    if (proto.typeV2) {
      m.typeV2 = enumStringToValue$d(FilterType, proto.typeV2);
    }
    if (proto.supportedOperatorsV2) {
      m.supportedOperatorsV2 = proto.supportedOperatorsV2.map(v => enumStringToValue$d(FilterOperator, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.hasFilterOptions !== 'undefined') {
      toReturn['hasFilterOptions'] = this.hasFilterOptions;
    }
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.typeV2 !== 'undefined') {
      toReturn['typeV2'] = this.typeV2;
    }
    if (typeof this.supportedOperatorsV2 !== 'undefined') {
      toReturn['supportedOperatorsV2'] = this.supportedOperatorsV2;
    }
    return toReturn;
  }
}
class ListFiltersRequest {
  static fromProto(proto) {
    let m = new ListFiltersRequest();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedRequestOptions.fromProto(proto.paging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    return toReturn;
  }
}
class ListFiltersResponse {
  static fromProto(proto) {
    let m = new ListFiltersResponse();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedResponseMetadata.fromProto(proto.paging);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(FilterDefinition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListMultiLocationFiltersRequest {
  static fromProto(proto) {
    let m = new ListMultiLocationFiltersRequest();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedRequestOptions.fromProto(proto.paging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaces !== 'undefined') {
      toReturn['namespaces'] = this.namespaces;
    }
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListMultiLocationFiltersResponse {
  static fromProto(proto) {
    let m = new ListMultiLocationFiltersResponse();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedResponseMetadata.fromProto(proto.paging);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(FilterDefinition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Activity {
  static fromProto(proto) {
    let m = new Activity();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(FieldValue.fromProto);
    }
    if (proto.associations) {
      m.associations = proto.associations.map(ActivityAssociation.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    if (typeof this.associations !== 'undefined' && this.associations !== null) {
      toReturn['associations'] = 'toApiJson' in this.associations ? this.associations.toApiJson() : this.associations;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ActivityAssociation {
  static fromProto(proto) {
    let m = new ActivityAssociation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    return toReturn;
  }
}
class CreateActivityRequest {
  static fromProto(proto) {
    let m = new CreateActivityRequest();
    m = Object.assign(m, proto);
    if (proto.activity) {
      m.activity = Activity.fromProto(proto.activity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.activity !== 'undefined' && this.activity !== null) {
      toReturn['activity'] = 'toApiJson' in this.activity ? this.activity.toApiJson() : this.activity;
    }
    if (typeof this.autoPopulatePrimaryCompany !== 'undefined') {
      toReturn['autoPopulatePrimaryCompany'] = this.autoPopulatePrimaryCompany;
    }
    return toReturn;
  }
}
class CreateActivityResponse {
  static fromProto(proto) {
    let m = new CreateActivityResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    return toReturn;
  }
}
class DeleteActivityRequest {
  static fromProto(proto) {
    let m = new DeleteActivityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    return toReturn;
  }
}
class GetActivityMetricsRequest {
  static fromProto(proto) {
    let m = new GetActivityMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.metricTypes) {
      m.metricTypes = proto.metricTypes.map(v => enumStringToValue$c(MetricType, v));
    }
    if (proto.filters) {
      m.filters = FilterGroup.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.metricTypes !== 'undefined') {
      toReturn['metricTypes'] = this.metricTypes;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class GetActivityMetricsResponse {
  static fromProto(proto) {
    let m = new GetActivityMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.ownerMetricCounts) {
      m.ownerMetricCounts = proto.ownerMetricCounts.map(OwnerMetricCounts.fromProto);
    }
    if (proto.summaries) {
      m.summaries = proto.summaries.map(MetricSummary.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerMetricCounts !== 'undefined' && this.ownerMetricCounts !== null) {
      toReturn['ownerMetricCounts'] = 'toApiJson' in this.ownerMetricCounts ? this.ownerMetricCounts.toApiJson() : this.ownerMetricCounts;
    }
    if (typeof this.summaries !== 'undefined' && this.summaries !== null) {
      toReturn['summaries'] = 'toApiJson' in this.summaries ? this.summaries.toApiJson() : this.summaries;
    }
    return toReturn;
  }
}
class GetMultiActivityRequest {
  static fromProto(proto) {
    let m = new GetMultiActivityRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectIds !== 'undefined') {
      toReturn['crmObjectIds'] = this.crmObjectIds;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class GetMultiActivityResponse {
  static fromProto(proto) {
    let m = new GetMultiActivityResponse();
    m = Object.assign(m, proto);
    if (proto.activities) {
      m.activities = proto.activities.map(Activity.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activities !== 'undefined' && this.activities !== null) {
      toReturn['activities'] = 'toApiJson' in this.activities ? this.activities.toApiJson() : this.activities;
    }
    return toReturn;
  }
}
class ListActivitiesRequest {
  static fromProto(proto) {
    let m = new ListActivitiesRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.search) {
      m.search = CrmObjectSearch.fromProto(proto.search);
    }
    if (proto.sortBy) {
      m.sortBy = proto.sortBy.map(SortBy.fromProto);
    }
    if (proto.filtersV2) {
      m.filtersV2 = FilterGroup.fromProto(proto.filtersV2);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.search !== 'undefined' && this.search !== null) {
      toReturn['search'] = 'toApiJson' in this.search ? this.search.toApiJson() : this.search;
    }
    if (typeof this.sortBy !== 'undefined' && this.sortBy !== null) {
      toReturn['sortBy'] = 'toApiJson' in this.sortBy ? this.sortBy.toApiJson() : this.sortBy;
    }
    if (typeof this.filtersV2 !== 'undefined' && this.filtersV2 !== null) {
      toReturn['filtersV2'] = 'toApiJson' in this.filtersV2 ? this.filtersV2.toApiJson() : this.filtersV2;
    }
    return toReturn;
  }
}
class ListActivitiesResponse {
  static fromProto(proto) {
    let m = new ListActivitiesResponse();
    m = Object.assign(m, proto);
    if (proto.activities) {
      m.activities = proto.activities.map(Activity.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activities !== 'undefined' && this.activities !== null) {
      toReturn['activities'] = 'toApiJson' in this.activities ? this.activities.toApiJson() : this.activities;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListMultiLocationActivitiesRequest {
  static fromProto(proto) {
    let m = new ListMultiLocationActivitiesRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.search) {
      m.search = CrmObjectSearch.fromProto(proto.search);
    }
    if (proto.sortBy) {
      m.sortBy = proto.sortBy.map(SortBy.fromProto);
    }
    if (proto.filtersV2) {
      m.filtersV2 = FilterGroup.fromProto(proto.filtersV2);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaces !== 'undefined') {
      toReturn['namespaces'] = this.namespaces;
    }
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.search !== 'undefined' && this.search !== null) {
      toReturn['search'] = 'toApiJson' in this.search ? this.search.toApiJson() : this.search;
    }
    if (typeof this.sortBy !== 'undefined' && this.sortBy !== null) {
      toReturn['sortBy'] = 'toApiJson' in this.sortBy ? this.sortBy.toApiJson() : this.sortBy;
    }
    if (typeof this.filtersV2 !== 'undefined' && this.filtersV2 !== null) {
      toReturn['filtersV2'] = 'toApiJson' in this.filtersV2 ? this.filtersV2.toApiJson() : this.filtersV2;
    }
    return toReturn;
  }
}
class ListMultiLocationActivitiesResponse {
  static fromProto(proto) {
    let m = new ListMultiLocationActivitiesResponse();
    m = Object.assign(m, proto);
    if (proto.activities) {
      m.activities = proto.activities.map(Activity.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activities !== 'undefined' && this.activities !== null) {
      toReturn['activities'] = 'toApiJson' in this.activities ? this.activities.toApiJson() : this.activities;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class MetricCount {
  static fromProto(proto) {
    let m = new MetricCount();
    m = Object.assign(m, proto);
    if (proto.metricType) {
      m.metricType = enumStringToValue$c(MetricType, proto.metricType);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metricType !== 'undefined') {
      toReturn['metricType'] = this.metricType;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class MetricSummary {
  static fromProto(proto) {
    let m = new MetricSummary();
    m = Object.assign(m, proto);
    if (proto.metricType) {
      m.metricType = enumStringToValue$c(MetricType, proto.metricType);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metricType !== 'undefined') {
      toReturn['metricType'] = this.metricType;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.average !== 'undefined') {
      toReturn['average'] = this.average;
    }
    return toReturn;
  }
}
class OwnerMetricCounts {
  static fromProto(proto) {
    let m = new OwnerMetricCounts();
    m = Object.assign(m, proto);
    if (proto.metricCounts) {
      m.metricCounts = proto.metricCounts.map(MetricCount.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.metricCounts !== 'undefined' && this.metricCounts !== null) {
      toReturn['metricCounts'] = 'toApiJson' in this.metricCounts ? this.metricCounts.toApiJson() : this.metricCounts;
    }
    return toReturn;
  }
}
class UpdateActivityRequest {
  static fromProto(proto) {
    let m = new UpdateActivityRequest();
    m = Object.assign(m, proto);
    if (proto.activity) {
      m.activity = Activity.fromProto(proto.activity);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.activity !== 'undefined' && this.activity !== null) {
      toReturn['activity'] = 'toApiJson' in this.activity ? this.activity.toApiJson() : this.activity;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class ValidateActivityRequest {
  static fromProto(proto) {
    let m = new ValidateActivityRequest();
    m = Object.assign(m, proto);
    if (proto.activity) {
      m.activity = Activity.fromProto(proto.activity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.activity !== 'undefined' && this.activity !== null) {
      toReturn['activity'] = 'toApiJson' in this.activity ? this.activity.toApiJson() : this.activity;
    }
    return toReturn;
  }
}
class ValidateActivityResponse {
  static fromProto(proto) {
    let m = new ValidateActivityResponse();
    m = Object.assign(m, proto);
    if (proto.errors) {
      m.errors = proto.errors.map(ValidateActivityResponseValidationError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}
class ValidateActivityResponseValidationError {
  static fromProto(proto) {
    let m = new ValidateActivityResponseValidationError();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ruleId !== 'undefined') {
      toReturn['ruleId'] = this.ruleId;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Association {
  static fromProto(proto) {
    let m = new Association();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.associationId !== 'undefined') {
      toReturn['associationId'] = this.associationId;
    }
    if (typeof this.associationType !== 'undefined') {
      toReturn['associationType'] = this.associationType;
    }
    if (typeof this.fromId !== 'undefined') {
      toReturn['fromId'] = this.fromId;
    }
    if (typeof this.toId !== 'undefined') {
      toReturn['toId'] = this.toId;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.fromCrmObjectSubtype !== 'undefined') {
      toReturn['fromCrmObjectSubtype'] = this.fromCrmObjectSubtype;
    }
    if (typeof this.toCrmObjectSubtype !== 'undefined') {
      toReturn['toCrmObjectSubtype'] = this.toCrmObjectSubtype;
    }
    return toReturn;
  }
}
class CreateAssociationRequest {
  static fromProto(proto) {
    let m = new CreateAssociationRequest();
    m = Object.assign(m, proto);
    if (proto.association) {
      m.association = Association.fromProto(proto.association);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.association !== 'undefined' && this.association !== null) {
      toReturn['association'] = 'toApiJson' in this.association ? this.association.toApiJson() : this.association;
    }
    return toReturn;
  }
}
class CreateAssociationResponse {
  static fromProto(proto) {
    let m = new CreateAssociationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.associationId !== 'undefined') {
      toReturn['associationId'] = this.associationId;
    }
    return toReturn;
  }
}
class DeleteAssociationRequest {
  static fromProto(proto) {
    let m = new DeleteAssociationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.associationId !== 'undefined') {
      toReturn['associationId'] = this.associationId;
    }
    return toReturn;
  }
}
class FindAssociationsRequest {
  static fromProto(proto) {
    let m = new FindAssociationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.associationType !== 'undefined') {
      toReturn['associationType'] = this.associationType;
    }
    if (typeof this.fromIds !== 'undefined') {
      toReturn['fromIds'] = this.fromIds;
    }
    if (typeof this.toIds !== 'undefined') {
      toReturn['toIds'] = this.toIds;
    }
    return toReturn;
  }
}
class FindAssociationsResponse {
  static fromProto(proto) {
    let m = new FindAssociationsResponse();
    m = Object.assign(m, proto);
    if (proto.associations) {
      m.associations = proto.associations.map(Association.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.associations !== 'undefined' && this.associations !== null) {
      toReturn['associations'] = 'toApiJson' in this.associations ? this.associations.toApiJson() : this.associations;
    }
    return toReturn;
  }
}
class GetMultiAssociationRequest {
  static fromProto(proto) {
    let m = new GetMultiAssociationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.associationIds !== 'undefined') {
      toReturn['associationIds'] = this.associationIds;
    }
    return toReturn;
  }
}
class GetMultiAssociationResponse {
  static fromProto(proto) {
    let m = new GetMultiAssociationResponse();
    m = Object.assign(m, proto);
    if (proto.associations) {
      m.associations = proto.associations.map(Association.fromProto);
    }
    if (proto.statusCode) {
      m.statusCode = proto.statusCode.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.associations !== 'undefined' && this.associations !== null) {
      toReturn['associations'] = 'toApiJson' in this.associations ? this.associations.toApiJson() : this.associations;
    }
    if (typeof this.statusCode !== 'undefined') {
      toReturn['statusCode'] = this.statusCode;
    }
    return toReturn;
  }
}
class ListAssociationFieldOptionsRequest {
  static fromProto(proto) {
    let m = new ListAssociationFieldOptionsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.associationType !== 'undefined') {
      toReturn['associationType'] = this.associationType;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListAssociationFieldOptionsResponse {
  static fromProto(proto) {
    let m = new ListAssociationFieldOptionsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    return toReturn;
  }
}
class ListAssociationsRequest {
  static fromProto(proto) {
    let m = new ListAssociationsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filtersV2) {
      m.filtersV2 = FilterGroup.fromProto(proto.filtersV2);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filtersV2 !== 'undefined' && this.filtersV2 !== null) {
      toReturn['filtersV2'] = 'toApiJson' in this.filtersV2 ? this.filtersV2.toApiJson() : this.filtersV2;
    }
    return toReturn;
  }
}
class ListAssociationsResponse {
  static fromProto(proto) {
    let m = new ListAssociationsResponse();
    m = Object.assign(m, proto);
    if (proto.associations) {
      m.associations = proto.associations.map(Association.fromProto);
    }
    if (proto.statusCode) {
      m.statusCode = proto.statusCode.map(i => parseInt(i, 10));
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.associations !== 'undefined' && this.associations !== null) {
      toReturn['associations'] = 'toApiJson' in this.associations ? this.associations.toApiJson() : this.associations;
    }
    if (typeof this.statusCode !== 'undefined') {
      toReturn['statusCode'] = this.statusCode;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Tag {
  static fromProto(proto) {
    let m = new Tag();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tagValue !== 'undefined') {
      toReturn['tagValue'] = this.tagValue;
    }
    return toReturn;
  }
}
class UpdateAssociationRequest {
  static fromProto(proto) {
    let m = new UpdateAssociationRequest();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.associationId !== 'undefined') {
      toReturn['associationId'] = this.associationId;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CSVFile {
  static fromProto(proto) {
    let m = new CSVFile();
    m = Object.assign(m, proto);
    if (proto.headers) {
      m.headers = proto.headers.map(Header.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.size) {
      m.size = CSVSize.fromProto(proto.size);
    }
    if (proto.mappingSuggestions) {
      m.mappingSuggestions = proto.mappingSuggestions.map(CSVHeaderMapping.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.headers !== 'undefined' && this.headers !== null) {
      toReturn['headers'] = 'toApiJson' in this.headers ? this.headers.toApiJson() : this.headers;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.size !== 'undefined' && this.size !== null) {
      toReturn['size'] = 'toApiJson' in this.size ? this.size.toApiJson() : this.size;
    }
    if (typeof this.mappingSuggestions !== 'undefined' && this.mappingSuggestions !== null) {
      toReturn['mappingSuggestions'] = 'toApiJson' in this.mappingSuggestions ? this.mappingSuggestions.toApiJson() : this.mappingSuggestions;
    }
    return toReturn;
  }
}
class CSVHeaderMapping {
  static fromProto(proto) {
    let m = new CSVHeaderMapping();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.headerName !== 'undefined') {
      toReturn['headerName'] = this.headerName;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    return toReturn;
  }
}
class CSVSize {
  static fromProto(proto) {
    let m = new CSVSize();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totalRows !== 'undefined') {
      toReturn['totalRows'] = this.totalRows;
    }
    if (typeof this.isEstimate !== 'undefined') {
      toReturn['isEstimate'] = this.isEstimate;
    }
    return toReturn;
  }
}
class GetMultiFileUploadDataRequest {
  static fromProto(proto) {
    let m = new GetMultiFileUploadDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    return toReturn;
  }
}
class GetMultiFileUploadDataResponse {
  static fromProto(proto) {
    let m = new GetMultiFileUploadDataResponse();
    m = Object.assign(m, proto);
    if (proto.files) {
      m.files = proto.files.map(CSVFile.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.files !== 'undefined' && this.files !== null) {
      toReturn['files'] = 'toApiJson' in this.files ? this.files.toApiJson() : this.files;
    }
    return toReturn;
  }
}
class Header {
  static fromProto(proto) {
    let m = new Header();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.sampleData !== 'undefined') {
      toReturn['sampleData'] = this.sampleData;
    }
    return toReturn;
  }
}
class ImportFromFileRequest {
  static fromProto(proto) {
    let m = new ImportFromFileRequest();
    m = Object.assign(m, proto);
    if (proto.mappings) {
      m.mappings = proto.mappings.map(CSVHeaderMapping.fromProto);
    }
    if (proto.duplicateHandlingType) {
      m.duplicateHandlingType = enumStringToValue$a(DuplicateHandlingType, proto.duplicateHandlingType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    if (typeof this.mappings !== 'undefined' && this.mappings !== null) {
      toReturn['mappings'] = 'toApiJson' in this.mappings ? this.mappings.toApiJson() : this.mappings;
    }
    if (typeof this.duplicateHandlingType !== 'undefined') {
      toReturn['duplicateHandlingType'] = this.duplicateHandlingType;
    }
    return toReturn;
  }
}
class ListFileUploadsRequest {
  static fromProto(proto) {
    let m = new ListFileUploadsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    return toReturn;
  }
}
class ListFileUploadsResponse {
  static fromProto(proto) {
    let m = new ListFileUploadsResponse();
    m = Object.assign(m, proto);
    if (proto.files) {
      m.files = proto.files.map(CSVFile.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.files !== 'undefined' && this.files !== null) {
      toReturn['files'] = 'toApiJson' in this.files ? this.files.toApiJson() : this.files;
    }
    return toReturn;
  }
}
class MultiObjectTypeImportFromFileRequest {
  static fromProto(proto) {
    let m = new MultiObjectTypeImportFromFileRequest();
    m = Object.assign(m, proto);
    if (proto.mappings) {
      m.mappings = proto.mappings.map(CSVHeaderMapping.fromProto);
    }
    if (proto.duplicateHandlingType) {
      m.duplicateHandlingType = enumStringToValue$a(DuplicateHandlingType, proto.duplicateHandlingType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    if (typeof this.mappings !== 'undefined' && this.mappings !== null) {
      toReturn['mappings'] = 'toApiJson' in this.mappings ? this.mappings.toApiJson() : this.mappings;
    }
    if (typeof this.duplicateHandlingType !== 'undefined') {
      toReturn['duplicateHandlingType'] = this.duplicateHandlingType;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldGroup {
  static fromProto(proto) {
    let m = new FieldGroup();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldGroupId !== 'undefined') {
      toReturn['fieldGroupId'] = this.fieldGroupId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.fieldIds !== 'undefined') {
      toReturn['fieldIds'] = this.fieldIds;
    }
    return toReturn;
  }
}
class ListFieldGroupsRequest {
  static fromProto(proto) {
    let m = new ListFieldGroupsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListFieldGroupsResponse {
  static fromProto(proto) {
    let m = new ListFieldGroupsResponse();
    m = Object.assign(m, proto);
    if (proto.fieldGroups) {
      m.fieldGroups = proto.fieldGroups.map(FieldGroup.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldGroups !== 'undefined' && this.fieldGroups !== null) {
      toReturn['fieldGroups'] = 'toApiJson' in this.fieldGroups ? this.fieldGroups.toApiJson() : this.fieldGroups;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListMultiLocationFieldGroupsRequest {
  static fromProto(proto) {
    let m = new ListMultiLocationFieldGroupsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaces !== 'undefined') {
      toReturn['namespaces'] = this.namespaces;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListMultiLocationFieldGroupsResponse {
  static fromProto(proto) {
    let m = new ListMultiLocationFieldGroupsResponse();
    m = Object.assign(m, proto);
    if (proto.fieldGroups) {
      m.fieldGroups = proto.fieldGroups.map(FieldGroup.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldGroups !== 'undefined' && this.fieldGroups !== null) {
      toReturn['fieldGroups'] = 'toApiJson' in this.fieldGroups ? this.fieldGroups.toApiJson() : this.fieldGroups;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddFieldExtensionRequest {
  static fromProto(proto) {
    let m = new AddFieldExtensionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.extensionId !== 'undefined') {
      toReturn['extensionId'] = this.extensionId;
    }
    return toReturn;
  }
}
class CreateFieldExtensionRequest {
  static fromProto(proto) {
    let m = new CreateFieldExtensionRequest();
    m = Object.assign(m, proto);
    if (proto.extension) {
      m.extension = FieldExtension.fromProto(proto.extension);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.extension !== 'undefined' && this.extension !== null) {
      toReturn['extension'] = 'toApiJson' in this.extension ? this.extension.toApiJson() : this.extension;
    }
    return toReturn;
  }
}
class CreateFieldExtensionResponse {
  static fromProto(proto) {
    let m = new CreateFieldExtensionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.extensionId !== 'undefined') {
      toReturn['extensionId'] = this.extensionId;
    }
    return toReturn;
  }
}
class DeleteFieldExtensionRequest {
  static fromProto(proto) {
    let m = new DeleteFieldExtensionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.extensionId !== 'undefined') {
      toReturn['extensionId'] = this.extensionId;
    }
    return toReturn;
  }
}
class FieldExtension {
  static fromProto(proto) {
    let m = new FieldExtension();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.extensionId !== 'undefined') {
      toReturn['extensionId'] = this.extensionId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class GetMultiFieldExtensionRequest {
  static fromProto(proto) {
    let m = new GetMultiFieldExtensionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.extensionIds !== 'undefined') {
      toReturn['extensionIds'] = this.extensionIds;
    }
    return toReturn;
  }
}
class GetMultiFieldExtensionResponse {
  static fromProto(proto) {
    let m = new GetMultiFieldExtensionResponse();
    m = Object.assign(m, proto);
    if (proto.extensions) {
      m.extensions = proto.extensions.map(FieldExtension.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.extensions !== 'undefined' && this.extensions !== null) {
      toReturn['extensions'] = 'toApiJson' in this.extensions ? this.extensions.toApiJson() : this.extensions;
    }
    return toReturn;
  }
}
class ListAddedExtensionsRequest {
  static fromProto(proto) {
    let m = new ListAddedExtensionsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAddedExtensionsResponse {
  static fromProto(proto) {
    let m = new ListAddedExtensionsResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.extensionIds !== 'undefined') {
      toReturn['extensionIds'] = this.extensionIds;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class RemoveFieldExtensionRequest {
  static fromProto(proto) {
    let m = new RemoveFieldExtensionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.extensionId !== 'undefined') {
      toReturn['extensionId'] = this.extensionId;
    }
    return toReturn;
  }
}
class UpdateFieldExtensionRequest {
  static fromProto(proto) {
    let m = new UpdateFieldExtensionRequest();
    m = Object.assign(m, proto);
    if (proto.extension) {
      m.extension = FieldExtension.fromProto(proto.extension);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.extension !== 'undefined' && this.extension !== null) {
      toReturn['extension'] = 'toApiJson' in this.extension ? this.extension.toApiJson() : this.extension;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateParentNamespaceRequest {
  static fromProto(proto) {
    let m = new CreateParentNamespaceRequest();
    m = Object.assign(m, proto);
    if (proto.parentNamespace) {
      m.parentNamespace = ParentNamespace.fromProto(proto.parentNamespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.parentNamespace !== 'undefined' && this.parentNamespace !== null) {
      toReturn['parentNamespace'] = 'toApiJson' in this.parentNamespace ? this.parentNamespace.toApiJson() : this.parentNamespace;
    }
    return toReturn;
  }
}
class DeleteParentNamespaceRequest {
  static fromProto(proto) {
    let m = new DeleteParentNamespaceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetMultiParentNamespaceRequest {
  static fromProto(proto) {
    let m = new GetMultiParentNamespaceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetMultiParentNamespaceResponse {
  static fromProto(proto) {
    let m = new GetMultiParentNamespaceResponse();
    m = Object.assign(m, proto);
    if (proto.parentNamespace) {
      m.parentNamespace = proto.parentNamespace.map(ParentNamespace.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.parentNamespace !== 'undefined' && this.parentNamespace !== null) {
      toReturn['parentNamespace'] = 'toApiJson' in this.parentNamespace ? this.parentNamespace.toApiJson() : this.parentNamespace;
    }
    return toReturn;
  }
}
class ParentNamespace {
  static fromProto(proto) {
    let m = new ParentNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentNamespace !== 'undefined') {
      toReturn['parentNamespace'] = this.parentNamespace;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CrmPITExtraFields {
  static fromProto(proto) {
    let m = new CrmPITExtraFields();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(FieldValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    return toReturn;
  }
}
class CrmSearchPITParams {
  static fromProto(proto) {
    let m = new CrmSearchPITParams();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pitId !== 'undefined') {
      toReturn['pitId'] = this.pitId;
    }
    if (typeof this.lastSortResponse !== 'undefined') {
      toReturn['lastSortResponse'] = this.lastSortResponse;
    }
    if (typeof this.tiebreaker !== 'undefined') {
      toReturn['tiebreaker'] = this.tiebreaker;
    }
    return toReturn;
  }
}
class SearchPITCrmObjectsRequest {
  static fromProto(proto) {
    let m = new SearchPITCrmObjectsRequest();
    m = Object.assign(m, proto);
    if (proto.search) {
      m.search = CrmObjectSearch.fromProto(proto.search);
    }
    if (proto.sortBy) {
      m.sortBy = proto.sortBy.map(SortBy.fromProto);
    }
    if (proto.pitParams) {
      m.pitParams = CrmSearchPITParams.fromProto(proto.pitParams);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filtersV3) {
      m.filtersV3 = FilterGroup.fromProto(proto.filtersV3);
    }
    if (proto.filterGroups) {
      m.filterGroups = proto.filterGroups.map(FilterGroup.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.objectType !== 'undefined') {
      toReturn['objectType'] = this.objectType;
    }
    if (typeof this.search !== 'undefined' && this.search !== null) {
      toReturn['search'] = 'toApiJson' in this.search ? this.search.toApiJson() : this.search;
    }
    if (typeof this.sortBy !== 'undefined' && this.sortBy !== null) {
      toReturn['sortBy'] = 'toApiJson' in this.sortBy ? this.sortBy.toApiJson() : this.sortBy;
    }
    if (typeof this.pitParams !== 'undefined' && this.pitParams !== null) {
      toReturn['pitParams'] = 'toApiJson' in this.pitParams ? this.pitParams.toApiJson() : this.pitParams;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.filtersV3 !== 'undefined' && this.filtersV3 !== null) {
      toReturn['filtersV3'] = 'toApiJson' in this.filtersV3 ? this.filtersV3.toApiJson() : this.filtersV3;
    }
    if (typeof this.checkAccessOnly !== 'undefined') {
      toReturn['checkAccessOnly'] = this.checkAccessOnly;
    }
    if (typeof this.extraFieldId !== 'undefined') {
      toReturn['extraFieldId'] = this.extraFieldId;
    }
    if (typeof this.filterGroups !== 'undefined' && this.filterGroups !== null) {
      toReturn['filterGroups'] = 'toApiJson' in this.filterGroups ? this.filterGroups.toApiJson() : this.filterGroups;
    }
    return toReturn;
  }
}
class SearchPITCrmObjectsResponse {
  static fromProto(proto) {
    let m = new SearchPITCrmObjectsResponse();
    m = Object.assign(m, proto);
    if (proto.pitParams) {
      m.pitParams = CrmSearchPITParams.fromProto(proto.pitParams);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(CrmPITExtraFields.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectIds !== 'undefined') {
      toReturn['crmObjectIds'] = this.crmObjectIds;
    }
    if (typeof this.pitParams !== 'undefined' && this.pitParams !== null) {
      toReturn['pitParams'] = 'toApiJson' in this.pitParams ? this.pitParams.toApiJson() : this.pitParams;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CrmChangeLogIdentifiers {
  static fromProto(proto) {
    let m = new CrmChangeLogIdentifiers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.crmChangeId !== 'undefined') {
      toReturn['crmChangeId'] = this.crmChangeId;
    }
    return toReturn;
  }
}
class CrmObjectChangeLog {
  static fromProto(proto) {
    let m = new CrmObjectChangeLog();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(FieldValue.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmChangeId !== 'undefined') {
      toReturn['crmChangeId'] = this.crmChangeId;
    }
    if (typeof this.crmChangeSubtype !== 'undefined') {
      toReturn['crmChangeSubtype'] = this.crmChangeSubtype;
    }
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.createdByUserId !== 'undefined') {
      toReturn['createdByUserId'] = this.createdByUserId;
    }
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.updatedByUserId !== 'undefined') {
      toReturn['updatedByUserId'] = this.updatedByUserId;
    }
    return toReturn;
  }
}
class GetMultiCrmObjectChangeLogRequest {
  static fromProto(proto) {
    let m = new GetMultiCrmObjectChangeLogRequest();
    m = Object.assign(m, proto);
    if (proto.crmChangelogIdentifiers) {
      m.crmChangelogIdentifiers = proto.crmChangelogIdentifiers.map(CrmChangeLogIdentifiers.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmChangelogIdentifiers !== 'undefined' && this.crmChangelogIdentifiers !== null) {
      toReturn['crmChangelogIdentifiers'] = 'toApiJson' in this.crmChangelogIdentifiers ? this.crmChangelogIdentifiers.toApiJson() : this.crmChangelogIdentifiers;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    return toReturn;
  }
}
class GetMultiCrmObjectChangeLogResponse {
  static fromProto(proto) {
    let m = new GetMultiCrmObjectChangeLogResponse();
    m = Object.assign(m, proto);
    if (proto.changeLogs) {
      m.changeLogs = proto.changeLogs.map(CrmObjectChangeLog.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.changeLogs !== 'undefined' && this.changeLogs !== null) {
      toReturn['changeLogs'] = 'toApiJson' in this.changeLogs ? this.changeLogs.toApiJson() : this.changeLogs;
    }
    return toReturn;
  }
}
class ListChangeLogsRequest {
  static fromProto(proto) {
    let m = new ListChangeLogsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.sortBy) {
      m.sortBy = proto.sortBy.map(SortBy.fromProto);
    }
    if (proto.filtersV2) {
      m.filtersV2 = FilterGroup.fromProto(proto.filtersV2);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.sortBy !== 'undefined' && this.sortBy !== null) {
      toReturn['sortBy'] = 'toApiJson' in this.sortBy ? this.sortBy.toApiJson() : this.sortBy;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.filtersV2 !== 'undefined' && this.filtersV2 !== null) {
      toReturn['filtersV2'] = 'toApiJson' in this.filtersV2 ? this.filtersV2.toApiJson() : this.filtersV2;
    }
    return toReturn;
  }
}
class ListChangeLogsResponse {
  static fromProto(proto) {
    let m = new ListChangeLogsResponse();
    m = Object.assign(m, proto);
    if (proto.changeLogs) {
      m.changeLogs = proto.changeLogs.map(CrmObjectChangeLog.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.changeLogs !== 'undefined' && this.changeLogs !== null) {
      toReturn['changeLogs'] = 'toApiJson' in this.changeLogs ? this.changeLogs.toApiJson() : this.changeLogs;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateScoringDefinitionRequest {
  static fromProto(proto) {
    let m = new CreateScoringDefinitionRequest();
    m = Object.assign(m, proto);
    if (proto.scoringDefinition) {
      m.scoringDefinition = ScoringDefinition.fromProto(proto.scoringDefinition);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.scoringDefinition !== 'undefined' && this.scoringDefinition !== null) {
      toReturn['scoringDefinition'] = 'toApiJson' in this.scoringDefinition ? this.scoringDefinition.toApiJson() : this.scoringDefinition;
    }
    return toReturn;
  }
}
class CreateScoringDefinitionResponse {
  static fromProto(proto) {
    let m = new CreateScoringDefinitionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scoringDefinitionId !== 'undefined') {
      toReturn['scoringDefinitionId'] = this.scoringDefinitionId;
    }
    return toReturn;
  }
}
class DeleteScoringDefinitionRequest {
  static fromProto(proto) {
    let m = new DeleteScoringDefinitionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.scoringDefinitionId !== 'undefined') {
      toReturn['scoringDefinitionId'] = this.scoringDefinitionId;
    }
    return toReturn;
  }
}
class GetMultiScoringDefinitionRequest {
  static fromProto(proto) {
    let m = new GetMultiScoringDefinitionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.scoringDefinitionIds !== 'undefined') {
      toReturn['scoringDefinitionIds'] = this.scoringDefinitionIds;
    }
    return toReturn;
  }
}
class GetMultiScoringDefinitionResponse {
  static fromProto(proto) {
    let m = new GetMultiScoringDefinitionResponse();
    m = Object.assign(m, proto);
    if (proto.scoringDefinitions) {
      m.scoringDefinitions = proto.scoringDefinitions.map(ScoringDefinition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scoringDefinitions !== 'undefined' && this.scoringDefinitions !== null) {
      toReturn['scoringDefinitions'] = 'toApiJson' in this.scoringDefinitions ? this.scoringDefinitions.toApiJson() : this.scoringDefinitions;
    }
    return toReturn;
  }
}
class GetScoreRequest {
  static fromProto(proto) {
    let m = new GetScoreRequest();
    m = Object.assign(m, proto);
    if (proto.scoringIdentifier) {
      m.scoringIdentifier = ScoringIdentifier.fromProto(proto.scoringIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.scoringIdentifier !== 'undefined' && this.scoringIdentifier !== null) {
      toReturn['scoringIdentifier'] = 'toApiJson' in this.scoringIdentifier ? this.scoringIdentifier.toApiJson() : this.scoringIdentifier;
    }
    return toReturn;
  }
}
class GetScoreResponse {
  static fromProto(proto) {
    let m = new GetScoreResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    return toReturn;
  }
}
class ListScoringDefinitionsRequest {
  static fromProto(proto) {
    let m = new ListScoringDefinitionsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class ListScoringDefinitionsResponse {
  static fromProto(proto) {
    let m = new ListScoringDefinitionsResponse();
    m = Object.assign(m, proto);
    if (proto.scoringDefinitions) {
      m.scoringDefinitions = proto.scoringDefinitions.map(ScoringDefinition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scoringDefinitions !== 'undefined' && this.scoringDefinitions !== null) {
      toReturn['scoringDefinitions'] = 'toApiJson' in this.scoringDefinitions ? this.scoringDefinitions.toApiJson() : this.scoringDefinitions;
    }
    return toReturn;
  }
}
class ScoringDefinition {
  static fromProto(proto) {
    let m = new ScoringDefinition();
    m = Object.assign(m, proto);
    if (proto.scoringRules) {
      m.scoringRules = proto.scoringRules.map(ScoringRule.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.scoringRules !== 'undefined' && this.scoringRules !== null) {
      toReturn['scoringRules'] = 'toApiJson' in this.scoringRules ? this.scoringRules.toApiJson() : this.scoringRules;
    }
    if (typeof this.contribution !== 'undefined') {
      toReturn['contribution'] = this.contribution;
    }
    if (typeof this.scoringDefinitionId !== 'undefined') {
      toReturn['scoringDefinitionId'] = this.scoringDefinitionId;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class ScoringIdentifier {
  static fromProto(proto) {
    let m = new ScoringIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class ScoringObjectRule {
  static fromProto(proto) {
    let m = new ScoringObjectRule();
    m = Object.assign(m, proto);
    if (proto.filter) {
      m.filter = Filter.fromProto(proto.filter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    return toReturn;
  }
}
class ScoringRule {
  static fromProto(proto) {
    let m = new ScoringRule();
    m = Object.assign(m, proto);
    if (proto.objectRules) {
      m.objectRules = proto.objectRules.map(ScoringObjectRule.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.objectRules !== 'undefined' && this.objectRules !== null) {
      toReturn['objectRules'] = 'toApiJson' in this.objectRules ? this.objectRules.toApiJson() : this.objectRules;
    }
    return toReturn;
  }
}
class SetScoringDefinitionsForFieldIDRequest {
  static fromProto(proto) {
    let m = new SetScoringDefinitionsForFieldIDRequest();
    m = Object.assign(m, proto);
    if (proto.scoringDefinitions) {
      m.scoringDefinitions = proto.scoringDefinitions.map(ScoringDefinition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.scoringDefinitions !== 'undefined' && this.scoringDefinitions !== null) {
      toReturn['scoringDefinitions'] = 'toApiJson' in this.scoringDefinitions ? this.scoringDefinitions.toApiJson() : this.scoringDefinitions;
    }
    return toReturn;
  }
}
class ScoringObjectRuleValue {
  static fromProto(proto) {
    let m = new ScoringObjectRuleValue();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.boolean !== 'undefined') {
      toReturn['boolean'] = this.boolean;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.float !== 'undefined') {
      toReturn['float'] = this.float;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreatePipelineRequest {
  static fromProto(proto) {
    let m = new CreatePipelineRequest();
    m = Object.assign(m, proto);
    if (proto.pipeline) {
      m.pipeline = Pipeline.fromProto(proto.pipeline);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pipeline !== 'undefined' && this.pipeline !== null) {
      toReturn['pipeline'] = 'toApiJson' in this.pipeline ? this.pipeline.toApiJson() : this.pipeline;
    }
    return toReturn;
  }
}
class CreatePipelineResponse {
  static fromProto(proto) {
    let m = new CreatePipelineResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    return toReturn;
  }
}
class DeletePipelineRequest {
  static fromProto(proto) {
    let m = new DeletePipelineRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    return toReturn;
  }
}
class GetMultiPipelineRequest {
  static fromProto(proto) {
    let m = new GetMultiPipelineRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pipelineIds !== 'undefined') {
      toReturn['pipelineIds'] = this.pipelineIds;
    }
    return toReturn;
  }
}
class GetMultiPipelineResponse {
  static fromProto(proto) {
    let m = new GetMultiPipelineResponse();
    m = Object.assign(m, proto);
    if (proto.pipelines) {
      m.pipelines = proto.pipelines.map(Pipeline.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pipelines !== 'undefined' && this.pipelines !== null) {
      toReturn['pipelines'] = 'toApiJson' in this.pipelines ? this.pipelines.toApiJson() : this.pipelines;
    }
    return toReturn;
  }
}
class ListOptions {
  static fromProto(proto) {
    let m = new ListOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.objectType !== 'undefined') {
      toReturn['objectType'] = this.objectType;
    }
    return toReturn;
  }
}
class ListPipelinesRequest {
  static fromProto(proto) {
    let m = new ListPipelinesRequest();
    m = Object.assign(m, proto);
    if (proto.listOptions) {
      m.listOptions = ListOptions.fromProto(proto.listOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listOptions !== 'undefined' && this.listOptions !== null) {
      toReturn['listOptions'] = 'toApiJson' in this.listOptions ? this.listOptions.toApiJson() : this.listOptions;
    }
    return toReturn;
  }
}
class ListPipelinesResponse {
  static fromProto(proto) {
    let m = new ListPipelinesResponse();
    m = Object.assign(m, proto);
    if (proto.pipelines) {
      m.pipelines = proto.pipelines.map(Pipeline.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pipelines !== 'undefined' && this.pipelines !== null) {
      toReturn['pipelines'] = 'toApiJson' in this.pipelines ? this.pipelines.toApiJson() : this.pipelines;
    }
    return toReturn;
  }
}
class Pipeline {
  static fromProto(proto) {
    let m = new Pipeline();
    m = Object.assign(m, proto);
    if (proto.stages) {
      m.stages = proto.stages.map(Stage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.objectType !== 'undefined') {
      toReturn['objectType'] = this.objectType;
    }
    if (typeof this.stages !== 'undefined' && this.stages !== null) {
      toReturn['stages'] = 'toApiJson' in this.stages ? this.stages.toApiJson() : this.stages;
    }
    return toReturn;
  }
}
class Stage {
  static fromProto(proto) {
    let m = new Stage();
    m = Object.assign(m, proto);
    if (proto.filterGroup) {
      m.filterGroup = FilterGroup.fromProto(proto.filterGroup);
    }
    if (proto.mutations) {
      m.mutations = proto.mutations.map(FieldValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stageId !== 'undefined') {
      toReturn['stageId'] = this.stageId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.filterGroup !== 'undefined' && this.filterGroup !== null) {
      toReturn['filterGroup'] = 'toApiJson' in this.filterGroup ? this.filterGroup.toApiJson() : this.filterGroup;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
class UpdatePipelineRequest {
  static fromProto(proto) {
    let m = new UpdatePipelineRequest();
    m = Object.assign(m, proto);
    if (proto.pipeline) {
      m.pipeline = Pipeline.fromProto(proto.pipeline);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pipeline !== 'undefined' && this.pipeline !== null) {
      toReturn['pipeline'] = 'toApiJson' in this.pipeline ? this.pipeline.toApiJson() : this.pipeline;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateCustomObjectTypeRequest {
  static fromProto(proto) {
    let m = new CreateCustomObjectTypeRequest();
    m = Object.assign(m, proto);
    if (proto.customObjectType) {
      m.customObjectType = CustomObjectType.fromProto(proto.customObjectType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.customObjectType !== 'undefined' && this.customObjectType !== null) {
      toReturn['customObjectType'] = 'toApiJson' in this.customObjectType ? this.customObjectType.toApiJson() : this.customObjectType;
    }
    return toReturn;
  }
}
class CreateCustomObjectTypeResponse {
  static fromProto(proto) {
    let m = new CreateCustomObjectTypeResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customObjectTypeId !== 'undefined') {
      toReturn['customObjectTypeId'] = this.customObjectTypeId;
    }
    return toReturn;
  }
}
class CustomObjectType {
  static fromProto(proto) {
    let m = new CustomObjectType();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.customObjectTypeId !== 'undefined') {
      toReturn['customObjectTypeId'] = this.customObjectTypeId;
    }
    if (typeof this.singularObjectName !== 'undefined') {
      toReturn['singularObjectName'] = this.singularObjectName;
    }
    if (typeof this.pluralObjectName !== 'undefined') {
      toReturn['pluralObjectName'] = this.pluralObjectName;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class DeleteCustomObjectTypeRequest {
  static fromProto(proto) {
    let m = new DeleteCustomObjectTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.customObjectTypeId !== 'undefined') {
      toReturn['customObjectTypeId'] = this.customObjectTypeId;
    }
    return toReturn;
  }
}
class GetMultiCustomObjectTypeRequest {
  static fromProto(proto) {
    let m = new GetMultiCustomObjectTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.customObjectTypeIds !== 'undefined') {
      toReturn['customObjectTypeIds'] = this.customObjectTypeIds;
    }
    return toReturn;
  }
}
class GetMultiCustomObjectTypeResponse {
  static fromProto(proto) {
    let m = new GetMultiCustomObjectTypeResponse();
    m = Object.assign(m, proto);
    if (proto.customObjectTypes) {
      m.customObjectTypes = proto.customObjectTypes.map(CustomObjectType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customObjectTypes !== 'undefined' && this.customObjectTypes !== null) {
      toReturn['customObjectTypes'] = 'toApiJson' in this.customObjectTypes ? this.customObjectTypes.toApiJson() : this.customObjectTypes;
    }
    return toReturn;
  }
}
class ListCustomObjectTypesRequest {
  static fromProto(proto) {
    let m = new ListCustomObjectTypesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ListCustomObjectTypesResponse {
  static fromProto(proto) {
    let m = new ListCustomObjectTypesResponse();
    m = Object.assign(m, proto);
    if (proto.customObjectTypes) {
      m.customObjectTypes = proto.customObjectTypes.map(CustomObjectType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customObjectTypes !== 'undefined' && this.customObjectTypes !== null) {
      toReturn['customObjectTypes'] = 'toApiJson' in this.customObjectTypes ? this.customObjectTypes.toApiJson() : this.customObjectTypes;
    }
    return toReturn;
  }
}
class UpdateCustomObjectTypeRequest {
  static fromProto(proto) {
    let m = new UpdateCustomObjectTypeRequest();
    m = Object.assign(m, proto);
    if (proto.customObjectType) {
      m.customObjectType = CustomObjectType.fromProto(proto.customObjectType);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.customObjectType !== 'undefined' && this.customObjectType !== null) {
      toReturn['customObjectType'] = 'toApiJson' in this.customObjectType ? this.customObjectType.toApiJson() : this.customObjectType;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CrmExportObjectsRequest {
  static fromProto(proto) {
    let m = new CrmExportObjectsRequest();
    m = Object.assign(m, proto);
    if (proto.search) {
      m.search = CrmObjectSearch.fromProto(proto.search);
    }
    if (proto.filters) {
      m.filters = FilterGroup.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.objectType !== 'undefined') {
      toReturn['objectType'] = this.objectType;
    }
    if (typeof this.search !== 'undefined' && this.search !== null) {
      toReturn['search'] = 'toApiJson' in this.search ? this.search.toApiJson() : this.search;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'crm-api.vendasta-local.com',
  'test': '',
  'demo': 'crm-demo.apigateway.co',
  'prod': 'crm-prod.apigateway.co',
  'production': 'crm-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMActivityApiService = /*#__PURE__*/(() => {
  class CRMActivityApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createActivity(r) {
      const request = r.toApiJson ? r : new CreateActivityRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMActivityService/CreateActivity", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateActivityResponse.fromProto(resp)));
    }
    updateActivity(r) {
      const request = r.toApiJson ? r : new UpdateActivityRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMActivityService/UpdateActivity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiActivity(r) {
      const request = r.toApiJson ? r : new GetMultiActivityRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMActivityService/GetMultiActivity", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiActivityResponse.fromProto(resp)));
    }
    listActivities(r) {
      const request = r.toApiJson ? r : new ListActivitiesRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMActivityService/ListActivities", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActivitiesResponse.fromProto(resp)));
    }
    listActivityFilters(r) {
      const request = r.toApiJson ? r : new ListFiltersRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMActivityService/ListActivityFilters", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFiltersResponse.fromProto(resp)));
    }
    deleteActivity(r) {
      const request = r.toApiJson ? r : new DeleteActivityRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMActivityService/DeleteActivity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    validateActivity(r) {
      const request = r.toApiJson ? r : new ValidateActivityRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMActivityService/ValidateActivity", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateActivityResponse.fromProto(resp)));
    }
    listActivityFieldOptions(r) {
      const request = r.toApiJson ? r : new ListFieldOptionsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMActivityService/ListActivityFieldOptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFieldOptionsResponse.fromProto(resp)));
    }
    getActivityMetrics(r) {
      const request = r.toApiJson ? r : new GetActivityMetricsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMActivityService/GetActivityMetrics", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetActivityMetricsResponse.fromProto(resp)));
    }
  }
  CRMActivityApiService.ɵfac = function CRMActivityApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMActivityApiService)();
  };
  CRMActivityApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMActivityApiService,
    factory: CRMActivityApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMActivityApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMAssociationApiService = /*#__PURE__*/(() => {
  class CRMAssociationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createAssociation(r) {
      const request = r.toApiJson ? r : new CreateAssociationRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMAssociationService/CreateAssociation", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAssociationResponse.fromProto(resp)));
    }
    updateAssociation(r) {
      const request = r.toApiJson ? r : new UpdateAssociationRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMAssociationService/UpdateAssociation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiAssociation(r) {
      const request = r.toApiJson ? r : new GetMultiAssociationRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMAssociationService/GetMultiAssociation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAssociationResponse.fromProto(resp)));
    }
    listAssociation(r) {
      const request = r.toApiJson ? r : new ListAssociationsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMAssociationService/ListAssociation", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAssociationsResponse.fromProto(resp)));
    }
    listAssociationFilters(r) {
      const request = r.toApiJson ? r : new ListAssociationsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMAssociationService/ListAssociationFilters", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAssociationsResponse.fromProto(resp)));
    }
    deleteAssociation(r) {
      const request = r.toApiJson ? r : new DeleteAssociationRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMAssociationService/DeleteAssociation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listAssociationFieldOptions(r) {
      const request = r.toApiJson ? r : new ListAssociationFieldOptionsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMAssociationService/ListAssociationFieldOptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAssociationFieldOptionsResponse.fromProto(resp)));
    }
    findAssociations(r) {
      const request = r.toApiJson ? r : new FindAssociationsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMAssociationService/FindAssociations", request.toApiJson(), this.apiOptions()).pipe(map(resp => FindAssociationsResponse.fromProto(resp)));
    }
  }
  CRMAssociationApiService.ɵfac = function CRMAssociationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMAssociationApiService)();
  };
  CRMAssociationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMAssociationApiService,
    factory: CRMAssociationApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMAssociationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMChangeLogApiService = /*#__PURE__*/(() => {
  class CRMChangeLogApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiChangeLog(r) {
      const request = r.toApiJson ? r : new GetMultiCrmObjectChangeLogRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMChangeLogService/GetMultiChangeLog", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCrmObjectChangeLogResponse.fromProto(resp)));
    }
    listChangeLogs(r) {
      const request = r.toApiJson ? r : new ListChangeLogsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMChangeLogService/ListChangeLogs", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListChangeLogsResponse.fromProto(resp)));
    }
  }
  CRMChangeLogApiService.ɵfac = function CRMChangeLogApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMChangeLogApiService)();
  };
  CRMChangeLogApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMChangeLogApiService,
    factory: CRMChangeLogApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMChangeLogApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMCompanyApiService = /*#__PURE__*/(() => {
  class CRMCompanyApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createCompany(r) {
      const request = r.toApiJson ? r : new CreateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCompanyService/CreateCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCrmObjectResponse.fromProto(resp)));
    }
    updateCompany(r) {
      const request = r.toApiJson ? r : new UpdateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCompanyService/UpdateCompany", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiCompany(r) {
      const request = r.toApiJson ? r : new GetMultiCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCompanyService/GetMultiCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCrmObjectResponse.fromProto(resp)));
    }
    listCompanies(r) {
      const request = r.toApiJson ? r : new ListCrmObjectsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCompanyService/ListCompanies", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCrmObjectsResponse.fromProto(resp)));
    }
    listCompaniesFilters(r) {
      const request = r.toApiJson ? r : new ListFiltersRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCompanyService/ListCompaniesFilters", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFiltersResponse.fromProto(resp)));
    }
    deleteCompany(r) {
      const request = r.toApiJson ? r : new DeleteCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCompanyService/DeleteCompany", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    validateCompany(r) {
      const request = r.toApiJson ? r : new ValidateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCompanyService/ValidateCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateCrmObjectResponse.fromProto(resp)));
    }
    listCompanyFieldOptions(r) {
      const request = r.toApiJson ? r : new ListFieldOptionsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCompanyService/ListCompanyFieldOptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFieldOptionsResponse.fromProto(resp)));
    }
    startBulkCompanyCreate(r) {
      const request = r.toApiJson ? r : new StartBulkCompanyCreateRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCompanyService/StartBulkCompanyCreate", request.toApiJson(), this.apiOptions()).pipe(map(resp => StartBulkCompanyCreateResponse.fromProto(resp)));
    }
  }
  CRMCompanyApiService.ɵfac = function CRMCompanyApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMCompanyApiService)();
  };
  CRMCompanyApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMCompanyApiService,
    factory: CRMCompanyApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMCompanyApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMCustomObjectApiService = /*#__PURE__*/(() => {
  class CRMCustomObjectApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createCustomObject(r) {
      const request = r.toApiJson ? r : new CreateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectService/CreateCustomObject", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCrmObjectResponse.fromProto(resp)));
    }
    getMultiCustomObject(r) {
      const request = r.toApiJson ? r : new GetMultiCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectService/GetMultiCustomObject", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCrmObjectResponse.fromProto(resp)));
    }
    updateCustomObject(r) {
      const request = r.toApiJson ? r : new UpdateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectService/UpdateCustomObject", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteCustomObject(r) {
      const request = r.toApiJson ? r : new DeleteCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectService/DeleteCustomObject", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listCustomObjects(r) {
      const request = r.toApiJson ? r : new ListCrmObjectsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectService/ListCustomObjects", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCrmObjectsResponse.fromProto(resp)));
    }
    validateCustomObject(r) {
      const request = r.toApiJson ? r : new ValidateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectService/ValidateCustomObject", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateCrmObjectResponse.fromProto(resp)));
    }
    listCustomObjectFilters(r) {
      const request = r.toApiJson ? r : new ListFiltersRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectService/ListCustomObjectFilters", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFiltersResponse.fromProto(resp)));
    }
    listCustomObjectFieldOptions(r) {
      const request = r.toApiJson ? r : new ListFieldOptionsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectService/ListCustomObjectFieldOptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFieldOptionsResponse.fromProto(resp)));
    }
  }
  CRMCustomObjectApiService.ɵfac = function CRMCustomObjectApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMCustomObjectApiService)();
  };
  CRMCustomObjectApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMCustomObjectApiService,
    factory: CRMCustomObjectApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMCustomObjectApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMCustomObjectTypeApiService = /*#__PURE__*/(() => {
  class CRMCustomObjectTypeApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createCustomObjectType(r) {
      const request = r.toApiJson ? r : new CreateCustomObjectTypeRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectTypeService/CreateCustomObjectType", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCustomObjectTypeResponse.fromProto(resp)));
    }
    getMultiCustomObjectType(r) {
      const request = r.toApiJson ? r : new GetMultiCustomObjectTypeRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectTypeService/GetMultiCustomObjectType", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCustomObjectTypeResponse.fromProto(resp)));
    }
    updateCustomObjectType(r) {
      const request = r.toApiJson ? r : new UpdateCustomObjectTypeRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectTypeService/UpdateCustomObjectType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteCustomObjectType(r) {
      const request = r.toApiJson ? r : new DeleteCustomObjectTypeRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectTypeService/DeleteCustomObjectType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listCustomObjectTypes(r) {
      const request = r.toApiJson ? r : new ListCustomObjectTypesRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMCustomObjectTypeService/ListCustomObjectTypes", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCustomObjectTypesResponse.fromProto(resp)));
    }
  }
  CRMCustomObjectTypeApiService.ɵfac = function CRMCustomObjectTypeApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMCustomObjectTypeApiService)();
  };
  CRMCustomObjectTypeApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMCustomObjectTypeApiService,
    factory: CRMCustomObjectTypeApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMCustomObjectTypeApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMFieldExtensionAdminApiService = /*#__PURE__*/(() => {
  class CRMFieldExtensionAdminApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createFieldExtension(r) {
      const request = r.toApiJson ? r : new CreateFieldExtensionRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldExtensionAdminService/CreateFieldExtension", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateFieldExtensionResponse.fromProto(resp)));
    }
    getMultiFieldExtension(r) {
      const request = r.toApiJson ? r : new GetMultiFieldExtensionRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldExtensionAdminService/GetMultiFieldExtension", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiFieldExtensionResponse.fromProto(resp)));
    }
    updateFieldExtension(r) {
      const request = r.toApiJson ? r : new UpdateFieldExtensionRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldExtensionAdminService/UpdateFieldExtension", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteFieldExtension(r) {
      const request = r.toApiJson ? r : new DeleteFieldExtensionRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldExtensionAdminService/DeleteFieldExtension", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CRMFieldExtensionAdminApiService.ɵfac = function CRMFieldExtensionAdminApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMFieldExtensionAdminApiService)();
  };
  CRMFieldExtensionAdminApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMFieldExtensionAdminApiService,
    factory: CRMFieldExtensionAdminApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMFieldExtensionAdminApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMFieldExtensionApiService = /*#__PURE__*/(() => {
  class CRMFieldExtensionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    addFieldExtension(r) {
      const request = r.toApiJson ? r : new AddFieldExtensionRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldExtensionService/AddFieldExtension", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeFieldExtension(r) {
      const request = r.toApiJson ? r : new RemoveFieldExtensionRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldExtensionService/RemoveFieldExtension", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listAddedExtensions(r) {
      const request = r.toApiJson ? r : new ListAddedExtensionsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldExtensionService/ListAddedExtensions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAddedExtensionsResponse.fromProto(resp)));
    }
  }
  CRMFieldExtensionApiService.ɵfac = function CRMFieldExtensionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMFieldExtensionApiService)();
  };
  CRMFieldExtensionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMFieldExtensionApiService,
    factory: CRMFieldExtensionApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMFieldExtensionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMFieldLayoutApiService = /*#__PURE__*/(() => {
  class CRMFieldLayoutApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listFieldGroups(r) {
      const request = r.toApiJson ? r : new ListFieldGroupsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldLayoutService/ListFieldGroups", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFieldGroupsResponse.fromProto(resp)));
    }
  }
  CRMFieldLayoutApiService.ɵfac = function CRMFieldLayoutApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMFieldLayoutApiService)();
  };
  CRMFieldLayoutApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMFieldLayoutApiService,
    factory: CRMFieldLayoutApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMFieldLayoutApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMFieldSchemaCustomizationApiService = /*#__PURE__*/(() => {
  class CRMFieldSchemaCustomizationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createFieldSchemaCustomization(r) {
      const request = r.toApiJson ? r : new CreateFieldSchemaCustomizationRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldSchemaCustomizationService/CreateFieldSchemaCustomization", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiFieldSchemaCustomization(r) {
      const request = r.toApiJson ? r : new GetMultiFieldSchemaCustomizationRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldSchemaCustomizationService/GetMultiFieldSchemaCustomization", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiFieldSchemaCustomizationResponse.fromProto(resp)));
    }
    updateFieldSchemaCustomization(r) {
      const request = r.toApiJson ? r : new UpdateFieldSchemaCustomizationRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldSchemaCustomizationService/UpdateFieldSchemaCustomization", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CRMFieldSchemaCustomizationApiService.ɵfac = function CRMFieldSchemaCustomizationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMFieldSchemaCustomizationApiService)();
  };
  CRMFieldSchemaCustomizationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMFieldSchemaCustomizationApiService,
    factory: CRMFieldSchemaCustomizationApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMFieldSchemaCustomizationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMFieldSchemaApiService = /*#__PURE__*/(() => {
  class CRMFieldSchemaApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createFieldSchema(r) {
      const request = r.toApiJson ? r : new CreateFieldSchemaRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldSchemaService/CreateFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateFieldSchemaResponse.fromProto(resp)));
    }
    getMultiFieldSchema(r) {
      const request = r.toApiJson ? r : new GetMultiFieldSchemaRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldSchemaService/GetMultiFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiFieldSchemaResponse.fromProto(resp)));
    }
    listFieldSchema(r) {
      const request = r.toApiJson ? r : new ListFieldSchemaRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldSchemaService/ListFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFieldSchemaResponse.fromProto(resp)));
    }
    updateFieldSchema(r) {
      const request = r.toApiJson ? r : new UpdateFieldSchemaRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldSchemaService/UpdateFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    archiveFieldSchema(r) {
      const request = r.toApiJson ? r : new ArchiveFieldSchemaRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldSchemaService/ArchiveFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unarchiveFieldSchema(r) {
      const request = r.toApiJson ? r : new UnarchiveFieldSchemaRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMFieldSchemaService/UnarchiveFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CRMFieldSchemaApiService.ɵfac = function CRMFieldSchemaApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMFieldSchemaApiService)();
  };
  CRMFieldSchemaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMFieldSchemaApiService,
    factory: CRMFieldSchemaApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMFieldSchemaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMImporterApiService = /*#__PURE__*/(() => {
  class CRMImporterApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    importFromFile(r) {
      const request = r.toApiJson ? r : new ImportFromFileRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMImporterService/ImportFromFile", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiFileUploadData(r) {
      const request = r.toApiJson ? r : new GetMultiFileUploadDataRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMImporterService/GetMultiFileUploadData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiFileUploadDataResponse.fromProto(resp)));
    }
    listFileUploads(r) {
      const request = r.toApiJson ? r : new ListFileUploadsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMImporterService/ListFileUploads", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFileUploadsResponse.fromProto(resp)));
    }
    multiObjectTypeImportFromFile(r) {
      const request = r.toApiJson ? r : new MultiObjectTypeImportFromFileRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMImporterService/MultiObjectTypeImportFromFile", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CRMImporterApiService.ɵfac = function CRMImporterApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMImporterApiService)();
  };
  CRMImporterApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMImporterApiService,
    factory: CRMImporterApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMImporterApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMMultiLocationActivityApiService = /*#__PURE__*/(() => {
  class CRMMultiLocationActivityApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listMultiLocationActivities(r) {
      const request = r.toApiJson ? r : new ListMultiLocationActivitiesRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMMultiLocationActivityService/ListMultiLocationActivities", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMultiLocationActivitiesResponse.fromProto(resp)));
    }
    listMultiLocationActivityFilters(r) {
      const request = r.toApiJson ? r : new ListMultiLocationFiltersRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMMultiLocationActivityService/ListMultiLocationActivityFilters", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMultiLocationFiltersResponse.fromProto(resp)));
    }
    listMultiLocationActivityFieldOptions(r) {
      const request = r.toApiJson ? r : new ListMultiLocationFieldOptionsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMMultiLocationActivityService/ListMultiLocationActivityFieldOptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMultiLocationFieldOptionsResponse.fromProto(resp)));
    }
  }
  CRMMultiLocationActivityApiService.ɵfac = function CRMMultiLocationActivityApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMMultiLocationActivityApiService)();
  };
  CRMMultiLocationActivityApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMMultiLocationActivityApiService,
    factory: CRMMultiLocationActivityApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMMultiLocationActivityApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMMultiLocationContactApiService = /*#__PURE__*/(() => {
  class CRMMultiLocationContactApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listMultiLocationContacts(r) {
      const request = r.toApiJson ? r : new ListMultiLocationCrmObjectsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMMultiLocationContactService/ListMultiLocationContacts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMultiLocationCrmObjectsResponse.fromProto(resp)));
    }
    listMultiLocationContactFilters(r) {
      const request = r.toApiJson ? r : new ListMultiLocationFiltersRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMMultiLocationContactService/ListMultiLocationContactFilters", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMultiLocationFiltersResponse.fromProto(resp)));
    }
    listMultiLocationContactFieldOptions(r) {
      const request = r.toApiJson ? r : new ListMultiLocationFieldOptionsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMMultiLocationContactService/ListMultiLocationContactFieldOptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMultiLocationFieldOptionsResponse.fromProto(resp)));
    }
  }
  CRMMultiLocationContactApiService.ɵfac = function CRMMultiLocationContactApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMMultiLocationContactApiService)();
  };
  CRMMultiLocationContactApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMMultiLocationContactApiService,
    factory: CRMMultiLocationContactApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMMultiLocationContactApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMMultiLocationFieldLayoutApiService = /*#__PURE__*/(() => {
  class CRMMultiLocationFieldLayoutApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listMultiLocationFieldGroups(r) {
      const request = r.toApiJson ? r : new ListMultiLocationFieldGroupsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMMultiLocationFieldLayoutService/ListMultiLocationFieldGroups", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMultiLocationFieldGroupsResponse.fromProto(resp)));
    }
  }
  CRMMultiLocationFieldLayoutApiService.ɵfac = function CRMMultiLocationFieldLayoutApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMMultiLocationFieldLayoutApiService)();
  };
  CRMMultiLocationFieldLayoutApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMMultiLocationFieldLayoutApiService,
    factory: CRMMultiLocationFieldLayoutApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMMultiLocationFieldLayoutApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMMultiLocationFieldSchemaApiService = /*#__PURE__*/(() => {
  class CRMMultiLocationFieldSchemaApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listMultiLocationFieldSchema(r) {
      const request = r.toApiJson ? r : new ListMultiLocationFieldSchemaRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMMultiLocationFieldSchemaService/ListMultiLocationFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMultiLocationFieldSchemaResponse.fromProto(resp)));
    }
  }
  CRMMultiLocationFieldSchemaApiService.ɵfac = function CRMMultiLocationFieldSchemaApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMMultiLocationFieldSchemaApiService)();
  };
  CRMMultiLocationFieldSchemaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMMultiLocationFieldSchemaApiService,
    factory: CRMMultiLocationFieldSchemaApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMMultiLocationFieldSchemaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMOpportunityApiService = /*#__PURE__*/(() => {
  class CRMOpportunityApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createOpportunity(r) {
      const request = r.toApiJson ? r : new CreateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMOpportunityService/CreateOpportunity", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCrmObjectResponse.fromProto(resp)));
    }
    updateOpportunity(r) {
      const request = r.toApiJson ? r : new UpdateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMOpportunityService/UpdateOpportunity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiOpportunity(r) {
      const request = r.toApiJson ? r : new GetMultiCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMOpportunityService/GetMultiOpportunity", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCrmObjectResponse.fromProto(resp)));
    }
    listOpportunities(r) {
      const request = r.toApiJson ? r : new ListCrmObjectsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMOpportunityService/ListOpportunities", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCrmObjectsResponse.fromProto(resp)));
    }
    listOpportunitiesFilters(r) {
      const request = r.toApiJson ? r : new ListFiltersRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMOpportunityService/ListOpportunitiesFilters", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFiltersResponse.fromProto(resp)));
    }
    deleteOpportunity(r) {
      const request = r.toApiJson ? r : new DeleteCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMOpportunityService/DeleteOpportunity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getOpportunityValueSummary(r) {
      const request = r.toApiJson ? r : new GetOpportunityValueSummaryRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMOpportunityService/GetOpportunityValueSummary", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOpportunityValueSummaryResponse.fromProto(resp)));
    }
    listOpportunityFieldOptions(r) {
      const request = r.toApiJson ? r : new ListFieldOptionsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMOpportunityService/ListOpportunityFieldOptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFieldOptionsResponse.fromProto(resp)));
    }
    validateOpportunity(r) {
      const request = r.toApiJson ? r : new ValidateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMOpportunityService/ValidateOpportunity", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateCrmObjectResponse.fromProto(resp)));
    }
  }
  CRMOpportunityApiService.ɵfac = function CRMOpportunityApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMOpportunityApiService)();
  };
  CRMOpportunityApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMOpportunityApiService,
    factory: CRMOpportunityApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMOpportunityApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMApiService = /*#__PURE__*/(() => {
  class CRMApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createContact(r) {
      const request = r.toApiJson ? r : new CreateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMService/CreateContact", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCrmObjectResponse.fromProto(resp)));
    }
    updateContact(r) {
      const request = r.toApiJson ? r : new UpdateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMService/UpdateContact", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiContact(r) {
      const request = r.toApiJson ? r : new GetMultiCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMService/GetMultiContact", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCrmObjectResponse.fromProto(resp)));
    }
    listContacts(r) {
      const request = r.toApiJson ? r : new ListCrmObjectsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMService/ListContacts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCrmObjectsResponse.fromProto(resp)));
    }
    listContactsFilters(r) {
      const request = r.toApiJson ? r : new ListFiltersRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMService/ListContactsFilters", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFiltersResponse.fromProto(resp)));
    }
    deleteContact(r) {
      const request = r.toApiJson ? r : new DeleteCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMService/DeleteContact", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    validateContact(r) {
      const request = r.toApiJson ? r : new ValidateCrmObjectRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMService/ValidateContact", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateCrmObjectResponse.fromProto(resp)));
    }
    listContactFieldOptions(r) {
      const request = r.toApiJson ? r : new ListFieldOptionsRequest(r);
      return this.http.post(this._host + "/crm.v1.CRMService/ListContactFieldOptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFieldOptionsResponse.fromProto(resp)));
    }
  }
  CRMApiService.ɵfac = function CRMApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMApiService)();
  };
  CRMApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMApiService,
    factory: CRMApiService.ɵfac,
    providedIn: 'root'
  });
  return CRMApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CrmSearchPITApiService = /*#__PURE__*/(() => {
  class CrmSearchPITApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    searchPointInTimeCrmObjects(r) {
      const request = r.toApiJson ? r : new SearchPITCrmObjectsRequest(r);
      return this.http.post(this._host + "/crm.v1.CrmSearchPITService/SearchPointInTimeCrmObjects", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchPITCrmObjectsResponse.fromProto(resp)));
    }
  }
  CrmSearchPITApiService.ɵfac = function CrmSearchPITApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CrmSearchPITApiService)();
  };
  CrmSearchPITApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CrmSearchPITApiService,
    factory: CrmSearchPITApiService.ɵfac,
    providedIn: 'root'
  });
  return CrmSearchPITApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let NamespaceAdminApiService = /*#__PURE__*/(() => {
  class NamespaceAdminApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createParentNamespace(r) {
      const request = r.toApiJson ? r : new CreateParentNamespaceRequest(r);
      return this.http.post(this._host + "/crm.v1.NamespaceAdminService/CreateParentNamespace", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiParentNamespace(r) {
      const request = r.toApiJson ? r : new GetMultiParentNamespaceRequest(r);
      return this.http.post(this._host + "/crm.v1.NamespaceAdminService/GetMultiParentNamespace", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiParentNamespaceResponse.fromProto(resp)));
    }
    deleteParentNamespace(r) {
      const request = r.toApiJson ? r : new DeleteParentNamespaceRequest(r);
      return this.http.post(this._host + "/crm.v1.NamespaceAdminService/DeleteParentNamespace", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  NamespaceAdminApiService.ɵfac = function NamespaceAdminApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NamespaceAdminApiService)();
  };
  NamespaceAdminApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NamespaceAdminApiService,
    factory: NamespaceAdminApiService.ɵfac,
    providedIn: 'root'
  });
  return NamespaceAdminApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PipelinesApiService = /*#__PURE__*/(() => {
  class PipelinesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createPipeline(r) {
      const request = r.toApiJson ? r : new CreatePipelineRequest(r);
      return this.http.post(this._host + "/crm.v1.Pipelines/CreatePipeline", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePipelineResponse.fromProto(resp)));
    }
    getMultiPipeline(r) {
      const request = r.toApiJson ? r : new GetMultiPipelineRequest(r);
      return this.http.post(this._host + "/crm.v1.Pipelines/GetMultiPipeline", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiPipelineResponse.fromProto(resp)));
    }
    updatePipeline(r) {
      const request = r.toApiJson ? r : new UpdatePipelineRequest(r);
      return this.http.post(this._host + "/crm.v1.Pipelines/UpdatePipeline", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deletePipeline(r) {
      const request = r.toApiJson ? r : new DeletePipelineRequest(r);
      return this.http.post(this._host + "/crm.v1.Pipelines/DeletePipeline", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listPipelines(r) {
      const request = r.toApiJson ? r : new ListPipelinesRequest(r);
      return this.http.post(this._host + "/crm.v1.Pipelines/ListPipelines", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPipelinesResponse.fromProto(resp)));
    }
  }
  PipelinesApiService.ɵfac = function PipelinesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PipelinesApiService)();
  };
  PipelinesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PipelinesApiService,
    factory: PipelinesApiService.ɵfac,
    providedIn: 'root'
  });
  return PipelinesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ScoringApiService = /*#__PURE__*/(() => {
  class ScoringApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createScoringDefinition(r) {
      const request = r.toApiJson ? r : new CreateScoringDefinitionRequest(r);
      return this.http.post(this._host + "/crm.v1.Scoring/CreateScoringDefinition", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateScoringDefinitionResponse.fromProto(resp)));
    }
    getMultiScoringDefinition(r) {
      const request = r.toApiJson ? r : new GetMultiScoringDefinitionRequest(r);
      return this.http.post(this._host + "/crm.v1.Scoring/GetMultiScoringDefinition", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiScoringDefinitionResponse.fromProto(resp)));
    }
    deleteScoringDefinition(r) {
      const request = r.toApiJson ? r : new DeleteScoringDefinitionRequest(r);
      return this.http.post(this._host + "/crm.v1.Scoring/DeleteScoringDefinition", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listScoringDefinitions(r) {
      const request = r.toApiJson ? r : new ListScoringDefinitionsRequest(r);
      return this.http.post(this._host + "/crm.v1.Scoring/ListScoringDefinitions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListScoringDefinitionsResponse.fromProto(resp)));
    }
    setScoringDefinitionsForFieldId(r) {
      const request = r.toApiJson ? r : new SetScoringDefinitionsForFieldIDRequest(r);
      return this.http.post(this._host + "/crm.v1.Scoring/SetScoringDefinitionsForFieldID", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getScore(r) {
      const request = r.toApiJson ? r : new GetScoreRequest(r);
      return this.http.post(this._host + "/crm.v1.Scoring/GetScore", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetScoreResponse.fromProto(resp)));
    }
  }
  ScoringApiService.ɵfac = function ScoringApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ScoringApiService)();
  };
  ScoringApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ScoringApiService,
    factory: ScoringApiService.ɵfac,
    providedIn: 'root'
  });
  return ScoringApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CRMFileUploadURLsService = /*#__PURE__*/(() => {
  class CRMFileUploadURLsService {
    constructor(hostService) {
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    getUploadFileURLForObject(objectType, namespace) {
      switch (objectType) {
        case "Contact":
          return `${this._host}/upload/contacts?namespace=${namespace}`;
        default:
          return `${this._host}/upload/multi?namespace=${namespace}`;
      }
    }
  }
  CRMFileUploadURLsService.ɵfac = function CRMFileUploadURLsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMFileUploadURLsService)(i0.ɵɵinject(HostService));
  };
  CRMFileUploadURLsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMFileUploadURLsService,
    factory: CRMFileUploadURLsService.ɵfac,
    providedIn: 'root'
  });
  return CRMFileUploadURLsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CRMExportService = /*#__PURE__*/(() => {
  class CRMExportService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    exportCSV(namespace, objectType, searchTerm, filters) {
      const url = `${this._host}/export/objects`;
      /* eslint-disable */
      const request = {
        namespace: namespace,
        objectType: objectType
      };
      if (!!searchTerm) {
        request.search = new CrmObjectSearch({
          searchTerm: searchTerm
        });
      }
      if (!!filters) {
        request.filters = new FilterGroup(filters);
      }
      /* eslint-enable */
      return this.http.post(url, new CrmExportObjectsRequest(request).toApiJson(), {
        observe: 'response',
        responseType: 'blob',
        withCredentials: true
      }).pipe(map(response => {
        const contentDisposition = response.headers.get('content-disposition') || 'crm-export.csv';
        const filename = contentDisposition.replace('attachment; filename=', '').replace(/"/g, '');
        return {
          filename: filename,
          blob: response.body || new Blob([], {
            type: 'text/csv'
          })
        };
      }));
    }
  }
  CRMExportService.ɵfac = function CRMExportService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CRMExportService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CRMExportService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CRMExportService,
    factory: CRMExportService.ɵfac,
    providedIn: 'root'
  });
  return CRMExportService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// MANUALLY CREATED FILE

/**
 * Generated bundle index. Do not edit.
 */

export { Access, Activity, ActivityAssociation, AddFieldExtensionRequest, ArchiveFieldSchemaRequest, Association, CRMActivityApiService, CRMApiService, CRMAssociationApiService, CRMChangeLogApiService, CRMCompanyApiService, CRMCustomObjectApiService, CRMCustomObjectTypeApiService, CRMExportService, CRMFieldExtensionAdminApiService, CRMFieldExtensionApiService, CRMFieldLayoutApiService, CRMFieldSchemaApiService, CRMFieldSchemaCustomizationApiService, CRMFileUploadURLsService, CRMImporterApiService, CRMMultiLocationActivityApiService, CRMMultiLocationContactApiService, CRMMultiLocationFieldLayoutApiService, CRMMultiLocationFieldSchemaApiService, CRMOpportunityApiService, CSVFile, CSVHeaderMapping, CSVSize, CreateActivityRequest, CreateActivityResponse, CreateAssociationRequest, CreateAssociationResponse, CreateCrmObjectRequest, CreateCrmObjectResponse, CreateCustomObjectTypeRequest, CreateCustomObjectTypeResponse, CreateFieldExtensionRequest, CreateFieldExtensionResponse, CreateFieldSchemaCustomizationRequest, CreateFieldSchemaRequest, CreateFieldSchemaResponse, CreateParentNamespaceRequest, CreatePipelineRequest, CreatePipelineResponse, CreateScoringDefinitionRequest, CreateScoringDefinitionResponse, CrmChangeLogIdentifiers, CrmExportObjectsRequest, CrmObject, CrmObjectChangeLog, CrmObjectSearch, CrmPITExtraFields, CrmSearchPITApiService, CrmSearchPITParams, Currency, CustomObjectType, DateDefault, DeleteActivityRequest, DeleteAssociationRequest, DeleteCrmObjectRequest, DeleteCustomObjectTypeRequest, DeleteFieldExtensionRequest, DeleteParentNamespaceRequest, DeletePipelineRequest, DeleteScoringDefinitionRequest, DropdownOption, DuplicateHandlingType, FieldExtension, FieldGroup, FieldMask, FieldSchema, FieldSchemaCustomization, FieldType, FieldValue, Filter, FilterDefinition, FilterGroup, FilterGroupOperator, FilterOperator, FilterType, FilterValue, FindAssociationsRequest, FindAssociationsResponse, Geopoint, GetActivityMetricsRequest, GetActivityMetricsResponse, GetMultiActivityRequest, GetMultiActivityResponse, GetMultiAssociationRequest, GetMultiAssociationResponse, GetMultiCrmObjectChangeLogRequest, GetMultiCrmObjectChangeLogResponse, GetMultiCrmObjectRequest, GetMultiCrmObjectResponse, GetMultiCustomObjectTypeRequest, GetMultiCustomObjectTypeResponse, GetMultiFieldExtensionRequest, GetMultiFieldExtensionResponse, GetMultiFieldSchemaCustomizationRequest, GetMultiFieldSchemaCustomizationResponse, GetMultiFieldSchemaRequest, GetMultiFieldSchemaResponse, GetMultiFileUploadDataRequest, GetMultiFileUploadDataResponse, GetMultiParentNamespaceRequest, GetMultiParentNamespaceResponse, GetMultiPipelineRequest, GetMultiPipelineResponse, GetMultiScoringDefinitionRequest, GetMultiScoringDefinitionResponse, GetOpportunityValueSummaryRequest, GetOpportunityValueSummaryResponse, GetOpportunityValueSummaryResponseAmounts, GetOpportunityValueSummaryResponseStageAmounts, GetScoreRequest, GetScoreResponse, Header, HostService, ImportFromFileRequest, ListActivitiesRequest, ListActivitiesResponse, ListAddedExtensionsRequest, ListAddedExtensionsResponse, ListAssociationFieldOptionsRequest, ListAssociationFieldOptionsResponse, ListAssociationsRequest, ListAssociationsResponse, ListChangeLogsRequest, ListChangeLogsResponse, ListCrmObjectsRequest, ListCrmObjectsResponse, ListCustomObjectTypesRequest, ListCustomObjectTypesResponse, ListFieldGroupsRequest, ListFieldGroupsResponse, ListFieldOptionsRequest, ListFieldOptionsResponse, ListFieldSchemaRequest, ListFieldSchemaRequestFilters, ListFieldSchemaResponse, ListFileUploadsRequest, ListFileUploadsResponse, ListFiltersRequest, ListFiltersResponse, ListMultiLocationActivitiesRequest, ListMultiLocationActivitiesResponse, ListMultiLocationCrmObjectsRequest, ListMultiLocationCrmObjectsResponse, ListMultiLocationFieldGroupsRequest, ListMultiLocationFieldGroupsResponse, ListMultiLocationFieldOptionsRequest, ListMultiLocationFieldOptionsResponse, ListMultiLocationFieldSchemaRequest, ListMultiLocationFieldSchemaRequestFilters, ListMultiLocationFieldSchemaResponse, ListMultiLocationFiltersRequest, ListMultiLocationFiltersResponse, ListOptions, ListPipelinesRequest, ListPipelinesResponse, ListScoringDefinitionsRequest, ListScoringDefinitionsResponse, MetricCount, MetricSummary, MetricType, MultiObjectTypeImportFromFileRequest, NamespaceAdminApiService, NullValue, ObjectProjectionFilter, OwnerMetricCounts, PagedRequestOptions, PagedResponseMetadata, ParentNamespace, Phone, PhoneFields, Pipeline, PipelinesApiService, ProjectionFilterType, RemoveFieldExtensionRequest, ScoringApiService, ScoringDefinition, ScoringIdentifier, ScoringObjectRule, ScoringObjectRuleValue, ScoringRule, SearchPITCrmObjectsRequest, SearchPITCrmObjectsResponse, SetScoringDefinitionsForFieldIDRequest, SortBy, SortDirection, Stage, StartBulkCompanyCreateRequest, StartBulkCompanyCreateResponse, StringList, Tag, UnarchiveFieldSchemaRequest, UpdateActivityRequest, UpdateAssociationRequest, UpdateCrmObjectRequest, UpdateCustomObjectTypeRequest, UpdateFieldExtensionRequest, UpdateFieldSchemaCustomizationRequest, UpdateFieldSchemaRequest, UpdatePipelineRequest, ValidateActivityRequest, ValidateActivityResponse, ValidateActivityResponseValidationError, ValidateCrmObjectRequest, ValidateCrmObjectResponse, ValidateCrmObjectResponseFieldUniqueness, ValidateCrmObjectResponseUniquenessCheck, ValidateCrmObjectResponseValidationError, ValidateCrmObjectResponseValidationErrorDetails, ValidateCrmObjectResponseValidationErrorSeverity };
